{
	"dialog.ok": "确定",
	"dialog.cancel": "取消",
	"dialog.confirm": "确认",
	"dialog.close": "关闭",
	"dialog.import": "导入",
	"dialog.save": "保存",
	"dialog.discard": "丢弃",
	"dialog.dontshowagain": "不再显示",
	"data.cube": "方块",
	"data.group": "分组",
	"data.texture": "纹理",
	"data.plugin": "插件",
	"data.preview": "预览",
	"data.toolbar": "工具栏",
	"data.image": "图片",
	"keys.ctrl": "Ctrl",
	"keys.shift": "Shift",
	"keys.alt": "Alt",
	"keys.meta": "Cmd",
	"keys.delete": "Delete",
	"keys.space": "空格",
	"keys.leftclick": "左键",
	"keys.middleclick": "中键",
	"keys.rightclick": "右键",
	"keys.tab": "Tab",
	"keys.backspace": "退格",
	"keys.enter": "Enter",
	"keys.escape": "Esc",
	"keys.function": "F%0",
	"keys.numpad": "小键盘 %0",
	"keys.caps": "大写锁定",
	"keys.menu": "菜单键",
	"keys.left": "Left",
	"keys.up": "Up",
	"keys.right": "Right",
	"keys.down": "Down",
	"keys.pageup": "Pg Up",
	"keys.pagedown": "Pg Dn",
	"keys.plus": "+",
	"keys.comma": ",",
	"keys.point": ".",
	"keys.minus": "-",
	"keys.cross": "/",
	"keys.end": "End",
	"keys.pos1": "Pos 1",
	"keys.printscreen": "Print Screen",
	"keys.pause": "Pause",
	"message.rotation_limit.title": "旋转限制",
	"message.rotation_limit.message": "Minecraft 将旋转限制为一个轴。在不同轴上旋转会清除其他轴上的所有旋转。如果您是因为其他目的建模并需要自由旋转，请将模型转换为“通用模型”。",
	"message.file_not_found.title": "未找到文件",
	"message.file_not_found.message": "Blockbench 找不到请求的文件。请确保它保存在本地而不是云中。",
	"message.screenshot.title": "截屏",
	"message.screenshot.clipboard": "剪贴板",
	"message.screenshot.right_click": "右键或长按截屏复制",
	"message.invalid_file.title": "文件无效",
	"message.invalid_file.message": "无法打开 Json 文件：%0",
	"message.invalid_model.title": "模型文件无效",
	"message.invalid_model.message": "文件不包含有效模型数据。",
	"message.child_model_only.title": "空的子模型",
	"message.child_model_only.message": "文件为 %0 的子文件，不包含模型。",
	"message.unsaved_textures.title": "纹理未保存",
	"message.unsaved_textures.message": "您的模型有未保存的纹理。 确保保存并放置在正确文件夹。",
	"message.model_clipping.title": "模型过大",
	"message.model_clipping.message": "您的模型包含 %0 个超出限制的方块。此模型将不适用于 Minecraft。",
	"message.loose_texture.title": "导入纹理",
	"message.loose_texture.message": "导入的纹理不在资源包中。Minecraft 只能加载资源包 textures 文件夹中的纹理。",
	"message.loose_texture.change": "更改路径",
	"message.update_res.title": "纹理尺寸",
	"message.update_res.message": "是否要将项目分辨率更改为此纹理的分辨率？如果您的纹理的分辨率高于正常值，请点击“取消”。",
	"message.update_res.update": "更新",
	"message.bedrock_overwrite_error.message": "Blockbench 无法将此模型与旧文件组合",
	"message.bedrock_overwrite_error.backup_overwrite": "创建备份并覆盖",
	"message.bedrock_overwrite_error.overwrite": "覆盖",
	"message.close_warning.message": "是否保存模型？",
	"message.close_warning.web": "当前项目将不被保存。确定要退出吗？",
	"message.default_textures.title": "默认纹理",
	"message.default_textures.message": "选择默认资源包的“textures”文件夹",
	"message.default_textures.detail": "从 Minecraft jar 中提取或从网上搜索默认资源包并下载。然后找到“textures”文件夹并将其打开。如果在当前资源包中找不到纹理，Blockbench 会尝试从此位置获取纹理。",
	"message.default_textures.select": "选择默认的“textures”文件夹",
	"message.image_editor.title": "选择图像编辑器",
	"message.image_editor.file": "选择文件...",
	"message.image_editor.exe": "选择图像编辑器的可执行文件",
	"message.display_skin.title": "Minecraft 皮肤",
	"message.display_skin.message": "从本地皮肤文件或输入正版用户名获取皮肤",
	"message.display_skin.upload": "上传皮肤",
	"message.display_skin.reset": "重置",
	"message.invalid_plugin": "无效的插件文件，请查看控制台",
	"message.load_plugin_app": "是否允许此插件更改计算机？请仅加载可信任的插件。",
	"message.load_plugin_web": "是否加载此插件？请仅加载可信任的插件。",
	"message.preset_no_info": "预设信息不包含此槽",
	"message.restart_to_update": "重启 Blockbench 应用更改",
	"message.save_file": "另存为 %0",
	"dialog.project.title": "项目",
	"dialog.project.name": "文件名",
	"dialog.project.parent": "父级模型",
	"dialog.project.geoname": "模型标识符",
	"dialog.project.ao": "环境光遮蔽",
	"dialog.texture.title": "纹理",
	"dialog.texture.variable": "变量",
	"dialog.texture.namespace": "命名空间",
	"dialog.texture.folder": "文件夹",
	"dialog.extrude.title": "拉伸图像",
	"dialog.extrude.mode": "扫描模式",
	"dialog.extrude.mode.areas": "区域",
	"dialog.extrude.mode.lines": "行",
	"dialog.extrude.mode.columns": "列",
	"dialog.extrude.mode.pixels": "像素",
	"dialog.extrude.opacity": "最小不透明度",
	"dialog.extrude.scan": "扫描并导入",
	"dialog.display_preset.title": "创建预设",
	"dialog.display_preset.message": "选择保存的槽位",
	"dialog.display_preset.create": "创建",
	"dialog.select.title": "选择",
	"dialog.select.group": "在选定分组中",
	"dialog.select.name": "名称包含",
	"dialog.select.random": "百分比随机（%）",
	"dialog.select.select": "选择",
	"dialog.scale.title": "缩放模型",
	"dialog.scale.axis": "轴",
	"dialog.scale.clipping": "模型裁剪：您的模型超出工作区范围",
	"dialog.scale.confirm": "应用缩放",
	"dialog.plugins.title": "插件",
	"dialog.plugins.installed": "已安装",
	"dialog.plugins.available": "可用",
	"dialog.plugins.install": "安装",
	"dialog.plugins.uninstall": "卸载",
	"dialog.plugins.reload": "重新加载",
	"dialog.plugins.none_installed": "未安装插件",
	"dialog.plugins.none_available": "无可用插件",
	"dialog.plugins.web_only": "仅网页版可用",
	"dialog.plugins.app_only": "仅桌面版可用",
	"dialog.plugins.author": "由%0制作",
	"dialog.create_texture.folder": "文件夹",
	"dialog.create_texture.resolution": "分辨率",
	"dialog.input.title": "输入",
	"dialog.settings.settings": "设置",
	"dialog.settings.keybinds": "快捷键",
	"dialog.settings.about": "关于",
	"layout.color.back": "底色",
	"layout.color.back.desc": "背景和文本框",
	"layout.color.dark": "暗色",
	"layout.color.dark.desc": "工作区背景",
	"layout.color.ui": "UI",
	"layout.color.ui.desc": "主题色",
	"layout.color.bright_ui": "高亮 UI",
	"layout.color.bright_ui.desc": "上下文菜单和工具提示",
	"layout.color.button": "按钮",
	"layout.color.button.desc": "按钮和开关",
	"layout.color.selected": "已选中",
	"layout.color.selected.desc": "已选标签和对象",
	"layout.color.border": "边框",
	"layout.color.border.desc": "按钮和输入边框",
	"layout.color.accent": "强调亮色",
	"layout.color.accent.desc": "滑块和其他",
	"layout.color.grid": "网格",
	"layout.color.grid.desc": "3D 预览网格",
	"layout.color.text": "文本",
	"layout.color.text.desc": "普通文本",
	"layout.color.light": "高亮",
	"layout.color.light.desc": "已选中文本",
	"layout.color.accent_text": "强调文本",
	"layout.color.accent_text.desc": "强调背景中的文本",
	"layout.font.main": "字体",
	"layout.font.headline": "标题字体",
	"about.version": "版本：",
	"settings.category.general": "常规",
	"settings.category.preview": "预览",
	"settings.category.grid": "网格",
	"settings.category.edit": "编辑",
	"settings.category.snapping": "吸附",
	"settings.category.defaults": "默认",
	"settings.category.dialogs": "对话框",
	"settings.category.export": "导出",
	"settings.language": "语言",
	"settings.language.desc": "界面语言",
	"settings.backup_interval": "备份间隔",
	"settings.backup_interval.desc": "以分钟为单位的自动备份间隔",
	"settings.origin_size": "枢轴长度",
	"settings.origin_size.desc": "枢轴控制点长度",
	"settings.control_size": "操作手柄尺寸",
	"settings.control_size.desc": "操作手柄的显示尺寸",
	"settings.display_skin": "Minecraft 皮肤",
	"settings.display_skin.desc": "用于显示玩家参考模型的皮肤",
	"settings.shading": "阴影",
	"settings.shading.desc": "预览时启用阴影",
	"settings.base_grid": "小网格",
	"settings.base_grid.desc": "显示小网格和轴",
	"settings.large_grid": "大网格",
	"settings.large_grid.desc": "显示 16x16 方块大小网格",
	"settings.full_grid": "精确大网格",
	"settings.full_grid.desc": "精确显示大网格",
	"settings.large_box": "大小限制盒子",
	"settings.large_box.desc": "显示大小限制边界",
	"settings.display_grid": "显示模式网格",
	"settings.display_grid.desc": "在显示模式下显示网格",
	"settings.undo_limit": "撤销限制",
	"settings.undo_limit.desc": "可撤销次数",
	"settings.local_move": "相对轴移动",
	"settings.local_move.desc": "如果可能，将根据自身的轴进行移动已旋转元素",
	"settings.canvas_unselect": "点击背景时取消选择",
	"settings.canvas_unselect.desc": "点击背景时取消所有元素选择",
	"settings.paint_side_restrict": "笔刷限制面",
	"settings.paint_side_restrict.desc": "限制笔刷仅在当前面进行绘画",
	"settings.autouv": "自动 UV",
	"settings.autouv.desc": "默认启用自动 UV",
	"settings.create_rename": "重命名新元素",
	"settings.create_rename.desc": "创建新元素或分组时优先对其命名",
	"settings.edit_size": "网格分辨率",
	"settings.edit_size.desc": "块移动时的网格距离",
	"settings.shift_size": "Shift 移动距离",
	"settings.shift_size.desc": "按住 Shift 时立方体移动的距离",
	"settings.ctrl_size": "Ctrl 移动距离",
	"settings.ctrl_size.desc": "按住 Ctrl 时立方体移动的距离",
	"settings.negative_size": "负值尺寸",
	"settings.negative_size.desc": "调整尺寸时使用负值",
	"settings.minifiedout": "简化导出",
	"settings.minifiedout.desc": "导出单行 JSON 文件",
	"settings.export_groups": "导出 Java 版方块/物品模型中的分组",
	"settings.export_groups.desc": "将分组保存在 Java 版方块或物品模型的 JSON 文件中",
	"settings.credit": "添加制作信息注释",
	"settings.credit.desc": "为导出的文件添加制作信息注释",
	"settings.default_path": "Minecraft 默认纹理路径",
	"settings.default_path.desc": "Blockbench 获取默认纹理的文件夹",
	"settings.image_editor": "图像编辑器",
	"settings.image_editor.desc": "默认修改纹理的图像编辑器",
	"category.navigate": "导航",
	"category.tools": "工具",
	"category.file": "文件",
	"category.blockbench": "Blockbench",
	"category.edit": "编辑",
	"category.transform": "变换",
	"category.view": "视图",
	"category.display": "显示设置",
	"category.textures": "纹理",
	"category.misc": "杂项",
	"keybind.preview_select": "选择",
	"keybind.preview_rotate": "旋转视图",
	"keybind.preview_drag": "拖动视图",
	"keybind.confirm": "确认",
	"keybind.cancel": "取消",
	"action.slider_inflate": "膨胀",
	"action.slider_inflate.desc": "不改变 UV 的情况下放大所选块",
	"action.slider_brush_size": "笔刷尺寸",
	"action.slider_brush_size.desc": "画笔的半径，单位 px",
	"action.slider_brush_opacity": "不透明度",
	"action.slider_brush_opacity.desc": "画笔的不透明度从 0 到 255",
	"action.slider_brush_softness": "柔软度",
	"action.slider_brush_softness.desc": "笔刷的柔软度",
	"action.uv_slider_pos_x": "水平移动",
	"action.uv_slider_pos_x.desc": "水平移动全部所选块的 UV",
	"action.uv_slider_pos_y": "垂直移动",
	"action.uv_slider_pos_y.desc": "垂直移动全部所选块的 UV",
	"action.uv_slider_size_x": "水平缩放",
	"action.uv_slider_size_x.desc": "水平缩放全部所选块的 UV",
	"action.uv_slider_size_y": "垂直缩放",
	"action.uv_slider_size_y.desc": "垂直缩放全部所选块的 UV",
	"action.vertex_snap_mode": "捕捉模式",
	"action.vertex_snap_mode.desc": "选择“顶点捕捉”模式为移动或缩放所选立方体的顶点",
	"action.move_tool": "移动",
	"action.move_tool.desc": "选择和移动元素的工具",
	"action.resize_tool": "调整大小",
	"action.resize_tool.desc": "选择和调整元素大小的工具",
	"action.brush_tool": "画笔",
	"action.brush_tool.desc": "在表面或 UV 编辑器上绘制位图纹理的工具",
	"action.vertex_snap_tool": "顶点捕捉",
	"action.vertex_snap_tool.desc": "移动所选块的顶点到另一个指定块的顶点",
	"action.swap_tools": "交换工具",
	"action.swap_tools.desc": "在调整大小和移动工具之间切换",
	"action.project_window": "项目...",
	"action.project_window.desc": "打开项目窗口，您可以在其中编辑模型的元数据",
	"action.open_model": "打开模型",
	"action.open_model.desc": "从本地打开模型文件",
	"action.extrude_texture": "拉伸纹理",
	"action.extrude_texture.desc": "通过拉伸纹理生成模型",
	"action.export_blockmodel": "导出方块/物品模型",
	"action.export_blockmodel.desc": "导出 Minecraft Java 版方块或物品模型",
	"action.export_optifine_part": "导出 OptiFine JPM",
	"action.export_optifine_part.desc": "导出 OptiFine 实体模型的JPM",
	"action.export_optifine_full": "导出 OptiFine JEM",
	"action.export_optifine_full.desc": "导出完整的 OptiFine 实体模型",
	"action.export_obj": "导出 OBJ 模型",
	"action.export_obj.desc": "导出 Wavefront OBJ 模型以用于渲染或游戏引擎",
	"action.settings_window": "设置...",
	"action.settings_window.desc": "打开 Blockbench 设置对话框。",
	"action.plugins_window": "插件...",
	"action.plugins_window.desc": "打开插件商店窗口",
	"action.reset_layout": "重置布局",
	"action.reset_layout.desc": "将布局重置为 Blockbench 默认值",
	"action.load_plugin": "从文件加载插件",
	"action.load_plugin.desc": "通过导入源文件加载插件",
	"action.reload_plugins": "重新加载插件",
	"action.reload_plugins.desc": "重新加载所有开发插件",
	"action.undo": "撤销",
	"action.undo.desc": "撤销上次更改",
	"action.redo": "重做",
	"action.redo.desc": "还原上一次撤销",
	"action.copy": "复制",
	"action.copy.desc": "复制所选内容、面或显示设置",
	"action.paste": "粘贴",
	"action.paste.desc": "粘贴所选内容、面或显示设置",
	"action.cut": "剪切",
	"action.cut.desc": "剪切所选内容、面或显示设置",
	"action.add_cube": "添加块",
	"action.add_cube.desc": "添加一个新的块",
	"action.add_group": "添加分组",
	"action.add_group.desc": "添加一个新的分组或骨骼",
	"action.outliner_toggle": "显示更多选项",
	"action.outliner_toggle.desc": "切换显示大纲中的更多选项",
	"action.duplicate": "复制元素",
	"action.delete": "删除",
	"action.sort_outliner": "大纲排序",
	"action.sort_outliner.desc": "按字母顺序排列大纲",
	"action.select_window": "选择...",
	"action.select_window.desc": "根据属性搜索并选择块",
	"action.invert_selection": "反选",
	"action.invert_selection.desc": "反向选择所选块",
	"action.select_all": "选择全部",
	"action.collapse_groups": "折叠分组",
	"action.collapse_groups.desc": "折叠大纲视图中所有分组",
	"action.scale": "缩放...",
	"action.scale.desc": "缩放所选块",
	"action.toggle_visibility": "可见性",
	"action.toggle_visibility.desc": "切换所选块的可见性",
	"action.toggle_export": "导出",
	"action.toggle_export.desc": "切换所选块的导出设置",
	"action.toggle_autouv": "自动 UV",
	"action.toggle_autouv.desc": "切换所选块的自动 UV 设置",
	"action.toggle_shade": "切换阴影",
	"action.toggle_shade.desc": "切换所选块的阴影",
	"action.rename": "重命名",
	"action.rename.desc": "更改所选块的名称",
	"action.add_display_preset": "新建预设",
	"action.add_display_preset.desc": "添加新的显示设置预设",
	"action.fullscreen": "全屏",
	"action.fullscreen.desc": "切换全屏模式",
	"action.zoom_in": "放大",
	"action.zoom_in.desc": "放大界面",
	"action.zoom_out": "缩小",
	"action.zoom_out.desc": "缩小界面",
	"action.zoom_reset": "重置缩放",
	"action.zoom_reset.desc": "将缩放重置为默认值 100%",
	"action.reset_interface": "重置界面",
	"action.reset_interface.desc": "重置 GUI 的大小和位置",
	"action.screenshot_model": "截屏模型",
	"action.screenshot_model.desc": "从当前角度拍摄模型剪裁过的截屏",
	"action.screenshot_app": "应用截屏",
	"action.screenshot_app.desc": "截取整个应用程序的截屏",
	"action.import_texture": "导入纹理",
	"action.import_texture.desc": "从本地导入一个或多个纹理",
	"action.create_texture": "创建纹理",
	"action.create_texture.desc": "创建空白纹理或纹理模板",
	"action.save_textures": "保存纹理",
	"action.save_textures.desc": "保存所有未保存的纹理",
	"action.animated_textures": "播放动态纹理",
	"action.animated_textures.desc": "播放和暂停动画纹理的预览",
	"action.origin_to_geometry": "枢轴居中",
	"action.origin_to_geometry.desc": "将轴心点设置为选区的中心",
	"action.bone_reset_toggle": "重置骨骼",
	"action.bone_reset_toggle.desc": "阻止骨骼显示来自父级型的立方体",
	"action.reload": "重启 Blockbench",
	"action.reload.desc": "重启 Blockbench。你未保存的项目将会丢失",
	"menu.file": "文件",
	"menu.edit": "编辑",
	"menu.transform": "变换",
	"menu.display": "显示",
	"menu.view": "视图",
	"menu.file.new": "新建",
	"menu.file.recent": "最近",
	"menu.file.import": "导入",
	"menu.file.export": "导出",
	"menu.transform.rotate": "旋转",
	"menu.transform.flip": "翻转",
	"menu.transform.center": "居中",
	"menu.transform.properties": "属性",
	"menu.display.preset": "应用预设",
	"menu.display.preset_all": "应用全局预设",
	"menu.display.remove_preset": "移除预设",
	"menu.view.zoom": "缩放",
	"menu.view.background": "背景",
	"menu.view.screenshot": "截屏",
	"menu.cube.color": "颜色标记",
	"menu.cube.texture": "纹理",
	"menu.cube.texture.transparent": "透明度",
	"menu.cube.texture.blank": "空白",
	"menu.group.sort": "排序",
	"menu.texture.face": "应用到面",
	"menu.texture.file": "文件",
	"menu.texture.refresh": "刷新",
	"menu.texture.change": "更改文件",
	"menu.texture.folder": "在文件夹中打开",
	"menu.texture.edit": "编辑",
	"menu.texture.export": "另存为",
	"menu.texture.save": "保存",
	"menu.texture.properties": "属性...",
	"menu.preview.background": "背景",
	"menu.preview.background.load": "加载",
	"menu.preview.background.position": "立方体位置",
	"menu.preview.background.lock": "锁定视角",
	"menu.preview.screenshot": "截屏",
	"menu.preview.perspective": "透视投影",
	"menu.preview.perspective.normal": "正常",
	"menu.preview.quadview": "四视图",
	"menu.preview.stop_drag": "停止背景定位",
	"menu.uv.mapping.rotation": "旋转",
	"menu.uv.texture": "纹理",
	"cube.color.light_blue": "淡蓝色",
	"cube.color.yellow": "黄色",
	"cube.color.orange": "橙色",
	"cube.color.red": "红色",
	"cube.color.purple": "紫色",
	"cube.color.blue": "蓝色",
	"cube.color.green": "绿色",
	"cube.color.lime": "黄绿色",
	"switches.visibility": "切换可见",
	"switches.export": "导出",
	"switches.autouv": "自动 UV",
	"panel.uv": "UV",
	"panel.display": "显示",
	"panel.textures": "纹理",
	"panel.outliner": "大纲",
	"uv_editor.title": "UV 编辑器",
	"uv_editor.all_faces": "全部",
	"uv_editor.no_faces": "无",
	"face.north": "北",
	"face.south": "南",
	"face.west": "西",
	"face.east": "东",
	"face.up": "顶",
	"face.down": "底",
	"direction.north": "北",
	"direction.south": "南",
	"direction.west": "西",
	"direction.east": "东",
	"direction.top": "顶",
	"direction.bottom": "底",
	"display.slot.third_right": "第三人称右手",
	"display.slot.third_left": "第三人称左手",
	"display.slot.first_right": "第一人称右手",
	"display.slot.first_left": "第一人称左手",
	"display.slot.head": "头部",
	"display.slot.ground": "掉落物",
	"display.slot.frame": "展示框",
	"display.slot.gui": "GUI",
	"display.rotation": "旋转",
	"display.translation": "偏移",
	"display.scale": "缩放",
	"display.slot": "槽位",
	"display.reference": "参考模型",
	"display.reference.player": "玩家",
	"display.reference.zombie": "僵尸",
	"display.reference.armor_stand": "盔甲架",
	"display.reference.baby_zombie": "小僵尸",
	"display.reference.armor_stand_small": "小型盔甲架",
	"display.reference.monitor": "普通",
	"display.reference.bow": "拉开的弓",
	"display.reference.block": "方块",
	"display.reference.frame": "物品展示框",
	"display.reference.inventory_nine": "3x3",
	"display.reference.inventory_full": "物品栏",
	"display.reference.hud": "快捷栏",
	"display.preset.blank_name": "请输入名称",
	"display.preset.item": "默认物品",
	"display.preset.block": "默认方块",
	"display.preset.handheld": "默认武器",
	"display.preset.rod": "默认棍子",
	"dialog.continue": "继续",
	"message.square_textures": "纹理必须是方形的",
	"message.unsaved_texture.title": "未保存的纹理",
	"message.unsaved_texture.message": "所有对此纹理的更改都将丢失。你想继续吗？",
	"action.vertex_snap_mode.move": "移动",
	"action.vertex_snap_mode.scale": "缩放",
	"action.open_model_folder": "打开模型文件夹",
	"action.open_model_folder.desc": "打开包含模型的文件夹",
	"action.change_textures_folder": "更改纹理位置",
	"action.change_textures_folder.desc": "更改保存所有纹理的文件夹",
	"menu.texture.particle": "用作粒子纹理",
	"message.update_notification.title": "无法更新版本",
	"message.update_notification.message": "有新的 Blockbench 版本可用。请在设置中开启自动更新进行下载！",
	"message.untextured": "该面没有纹理",
	"dialog.toolbar_edit.title": "自定义工具栏",
	"keybindings.reset": "重置",
	"keybindings.clear": "清空",
	"action.cube_counter": "模型统计",
	"action.uv_rotation": "UV 旋转",
	"action.uv_rotation.desc": "UV 面的旋转",
	"action.uv_grid": "UV 网格",
	"action.uv_grid.desc": "UV 选择器使用的网格分辨率",
	"action.uv_grid.auto": "自动",
	"action.uv_maximize": "最大化 UV",
	"action.uv_maximize.desc": "使此面的 UV 使用整张纹理",
	"action.uv_auto": "自动 UV",
	"action.uv_auto.desc": "将此面的 UV 大小设置为面的实际大小",
	"action.uv_rel_auto": "自动相对 UV",
	"action.uv_rel_auto.desc": "将此面的 UV 设置为实际面的位置和大小",
	"action.uv_mirror_x": "UV 镜像 X 轴",
	"action.uv_mirror_x.desc": "在 X 轴上镜像此面的 UV",
	"action.uv_mirror_y": "UV 镜像 Y 轴",
	"action.uv_mirror_y.desc": "在 Y 轴上镜像此面的 UV",
	"action.uv_transparent": "删除面",
	"action.uv_transparent.desc": "删除当前面",
	"action.uv_reset": "重置面",
	"action.uv_reset.desc": "重置当前面",
	"action.cullface": "剔除面",
	"action.cullface.desc": "如果覆盖了选定模型的面，则禁用此面的渲染",
	"action.auto_cullface": "自动剔除面",
	"action.auto_cullface.desc": "将此面的剔除面设置为自身",
	"action.face_tint": "着色",
	"action.face_tint.desc": "为当前面启用着色选项",
	"menu.toolbar.edit": "自定义工具栏",
	"menu.toolbar.reset": "重置工具栏",
	"uv_editor.rotated": "旋转",
	"uv_editor.auto_cull": "剔除面",
	"uv_editor.copied": "复制面",
	"uv_editor.pasted": "粘贴面",
	"uv_editor.copied_x": "复制了 %0 个面",
	"uv_editor.reset": "重置面",
	"uv_editor.maximized": "最大化",
	"uv_editor.autouv": "自动尺寸",
	"uv_editor.mirrored": "镜像",
	"uv_editor.to_all": "应用到所有面",
	"uv_editor.transparent": "设置为透明",
	"uv_editor.cullface_on": "开启面剔除",
	"uv_editor.cullface_off": "关闭面剔除",
	"uv_editor.tint_on": "开启着色",
	"uv_editor.tint_off": "关闭着色",
	"action.uv_apply_all": "应用到所有面",
	"action.uv_apply_all.desc": "将当前面的设置应用于所有面",
	"message.image_editor_missing.title": "默认图像编辑器",
	"message.image_editor_missing.message": "选择图像编辑器的可执行文件。",
	"message.image_editor_missing.detail": "Blockbench 在您的计算机上找不到图像编辑器。 请选择首选图像编辑器的可执行文件。",
	"action.update_autouv": "更新自动 UV",
	"action.update_autouv.desc": "更新所选块的自动 UV 映射",
	"category.uv": "UV",
	"status_bar.saved": "模型已保存",
	"status_bar.unsaved": "有未保存的更改",
	"action.move_up": "上移",
	"action.move_up.desc": "相对于当前视角向上移动所选块",
	"action.move_down": "下移",
	"action.move_down.desc": "相对于当前视角向下移动所选块",
	"action.move_left": "左移",
	"action.move_left.desc": "相对于当前视角向左移动所选块",
	"action.move_right": "右移",
	"action.move_right.desc": "相对于当前视角向右移动所选块",
	"action.move_forth": "前移",
	"action.move_forth.desc": "相对于当前视角向前移动所选块",
	"action.move_back": "后移",
	"action.move_back.desc": "相对于当前视角向后移动所选块",
	"layout.color.wireframe": "线框",
	"layout.color.wireframe.desc": "线框模式中的线",
	"action.add_animation": "添加动画",
	"action.add_animation.desc": "创建一个空白动画",
	"action.load_animation_file": "导入动画文件",
	"action.load_animation_file.desc": "导入动画文件",
	"action.play_animation": "播放动画",
	"action.play_animation.desc": "预览所选的动画",
	"action.slider_keyframe_time": "时间码",
	"action.slider_keyframe_time.desc": "修改选定关键帧的时间码",
	"timeline.rotation": "旋转",
	"timeline.position": "位置",
	"timeline.scale": "缩放",
	"menu.keyframe.quaternion": "四元数",
	"panel.animations": "动画",
	"panel.keyframe": "关键帧",
	"panel.keyframe.type": "关键帧（%0）",
	"generic.delete": "删除",
	"generic.rename": "重命名",
	"message.no_animation_selected": "你必须选中一个动画才能执行此操作",
	"message.no_bone_selected": "你必须选中一个骨骼才能执行此操作",
	"message.duplicate_groups.title": "复制骨骼名称",
	"message.duplicate_groups.message": "该骨骼的名称存在于多个骨骼。这可能会导致问题。",
	"action.delete_keyframes": "删除关键帧",
	"action.delete_keyframes.desc": "删除所有选定的关键帧",
	"menu.animation": "动画",
	"menu.animation.loop": "循环模式",
	"menu.animation.override": "覆盖",
	"menu.animation.anim_time_update": "更新变量",
	"message.display_skin_model.title": "皮肤模型",
	"message.display_skin_model.message": "选择皮肤模型的类型",
	"message.display_skin_model.classic": "经典",
	"message.display_skin_model.slim": "纤细",
	"message.bone_material": "改变骨骼材质",
	"action.slider_animation_length": "动画长度",
	"action.slider_animation_length.desc": "更改所选的动画长度",
	"panel.variable_placeholders": "变量占位符",
	"status_bar.vertex_distance": "距离：%0",
	"dialog.create_gif.title": "录制 GIF",
	"dialog.create_gif.length": "长度",
	"dialog.create_gif.fps": "FPS",
	"dialog.create_gif.play": "播放动画",
	"category.animation": "动画",
	"action.record_model_gif": "录制 GIF...",
	"action.record_model_gif.desc": "从当前角度记录模型的GIF动画",
	"display.mirror": "镜像",
	"data.separator": "分隔符",
	"menu.preview.background.set_position": "设置位置",
	"dialog.toolbar_edit.hidden": "隐藏",
	"action.export_class_entity": "导出为 Java 版实体",
	"action.export_class_entity.desc": "将实体模型导出为 Java 类文件",
	"settings.seethrough_outline": "透视轮廓",
	"settings.seethrough_outline.desc": "显示所选元素被遮挡的轮廓",
	"mode.edit": "编辑模式",
	"mode.paint": "绘画模式",
	"mode.display": "显示调整",
	"mode.animate": "动画模式",
	"status_bar.recording_gif": "录制中",
	"status_bar.processing_gif": "处理中",
	"settings.backup_retain": "备份保留期限",
	"settings.backup_retain.desc": "设置 Blockbench 将旧备份保留多长时间",
	"action.rotate_tool": "旋转",
	"action.rotate_tool.desc": "用于选择和旋转立方体的工具",
	"action.fill_tool": "油漆桶",
	"action.fill_tool.desc": "用一种颜色填充整个面",
	"action.eraser": "橡皮擦",
	"action.eraser.desc": "使纹理上的颜色更改为透明色",
	"action.color_picker": "拾色器",
	"action.color_picker.desc": "获取纹理上像素的颜色",
	"switches.mirror": "镜像 UV",
	"language_name": "简体中文",
	"message.plugin_reload": "已重新载入 %0 个本地插件",
	"settings.brightness": "亮度",
	"settings.brightness.desc": "预览亮度。默认值为 50",
	"menu.preview.perspective.reset": "重置相机位置",
	"action.fill_mode": "填充模式",
	"action.fill_mode.face": "面",
	"action.fill_mode.color": "颜色",
	"action.toggle_mirror_uv": "镜像 UV",
	"action.toggle_mirror_uv.desc": "切换所选块于 X 轴的 UV 镜像",
	"menu.texture.blank": "应用到无纹理面",
	"dialog.scale.select_overflow": "选择溢出",
	"action.action_control": "动作控制",
	"action.action_control.desc": "搜索并且执行任何可用的操作",
	"keybindings.recording": "录制快捷键",
	"keybindings.press": "按一个键或组合键或单击屏幕上的任意位置来记录您的键绑定。",
	"action.pivot_tool": "枢轴工具",
	"action.pivot_tool.desc": "用于更改块和骨骼的旋转点的工具",
	"action.slider_animation_speed": "播放速度",
	"action.slider_animation_speed.desc": "时间线的播放速度以百分比表示",
	"action.previous_keyframe": "上一个关键帧",
	"action.previous_keyframe.desc": "转跳到上一个关键帧",
	"action.next_keyframe": "下一个关键帧",
	"action.next_keyframe.desc": "转跳到下一个关键帧",
	"message.outdated_client.title": "Blockbench 已过期",
	"message.outdated_client.message": "请更新到最新版本的 Blockbench 来执行此操作。",
	"action.export_asset_archive": "下载存档",
	"action.export_asset_archive.desc": "下载包含模型和纹理的存档",
	"action.upload_sketchfab": "上传到 Sketchfab...",
	"message.sketchfab.name_or_token": "请输入你的 Sketchfab token 和名称",
	"dialog.sketchfab_uploader.title": "上传 Sketchfab 模型",
	"dialog.sketchfab_uploader.token": "API Token",
	"dialog.sketchfab_uploader.about_token": "该令牌用于将 Blockbench 连接到您的 Sketchfab 帐户。您可以在 %0 上找到它",
	"dialog.sketchfab_uploader.name": "模型名称",
	"dialog.sketchfab_uploader.description": "描述",
	"dialog.sketchfab_uploader.tags": "标签",
	"settings.sketchfab_token": "Sketchfab Token",
	"settings.sketchfab_token.desc": "用于授权 Blockbench 上传到 Sketchfab 帐户的 Token",
	"panel.color": "颜色",
	"data.origin": "枢轴",
	"message.sketchfab.success": "成功上传模型",
	"message.sketchfab.error": "Sketchfab 模型上传失败",
	"settings.outliner_colors": "大纲颜色",
	"settings.outliner_colors.desc": "在大纲中显示立方体的颜色",
	"action.upload_sketchfab.desc": "将你的模型上传到 Sketchfab",
	"action.element_colors": "块的颜色",
	"action.element_colors.desc": "在大纲中显示块的颜色",
	"texture.error.file": "文件未找到",
	"texture.error.parent": "父模型提供的纹理文件",
	"message.recover_backup.title": "恢复模型",
	"message.recover_backup.message": "Blockbench 异常关闭。需要恢复模型吗？",
	"message.invalid_session.title": "无效的会话 Token",
	"message.invalid_session.message": "您尝试加入的会话已过期或提供的令牌无效。",
	"dialog.create_texture.power": "2 幂大小",
	"dialog.create_gif.turn": "旋转台速度",
	"action.edit_session": "编辑会话...",
	"action.edit_session.desc": "通过连接编辑会话来与其他用户进行协作",
	"action.reset_keyframe": "重置关键帧",
	"action.reset_keyframe.desc": "重置所选关键帧的所有值",
	"dialog.edit_session.title": "编辑会话",
	"edit_session.username": "用户名",
	"edit_session.token": "密码",
	"edit_session.about": "编辑会话用于联机协作处理模型。创建会话并复制令牌发送给朋友，然后他们可以使用它加入。",
	"edit_session.join": "加入会话",
	"edit_session.create": "创建会话",
	"edit_session.quit": "退出会话",
	"edit_session.joined": "%0 加入了会话",
	"edit_session.left": "%0 离开了会话",
	"edit_session.quit_session": "离开当前会话",
	"edit_session.status": "状态",
	"edit_session.hosting": "主机",
	"edit_session.connected": "连接到会话",
	"dialog.sketchfab_uploader.private": "私人（高级）",
	"dialog.sketchfab_uploader.password": "密码（高级）",
	"action.uv_select_all": "选择全部",
	"action.uv_select_all.desc": "在 UV 对话框中选择所有面",
	"panel.chat": "聊天",
	"edit_session.welcome": "欢迎加入 %0 的会话",
	"dialog.yes": "是",
	"dialog.no": "否",
	"generic.remove": "移除",
	"generic.download": "下载",
	"generic.search": "搜索",
	"dates.today": "今天",
	"dates.yesterday": "昨天",
	"dates.this_week": "本周",
	"dates.weeks_ago": "%0 周前",
	"mode.start.new": "新建",
	"mode.start.recent": "最近",
	"format.free": "通用模型",
	"format.free.desc": "无模型限制。用于游戏引擎、渲染等。",
	"format.java_block": "Java 版方块/物品",
	"format.java_block.desc": "Minecraft Java 版方块或物品模型。",
	"format.bedrock": "Bedrock 版实体",
	"format.bedrock.desc": "Bedrock 版实体和物品附件模型",
	"format.bedrock_old": "Bedrock 版旧版实体",
	"format.bedrock_old.desc": "Bedrock Pre-1.12 版实体模型",
	"format.modded_entity": "模组版实体",
	"format.modded_entity.desc": "Minecraft 模组的实体模型。可以导出为 .java 类文件。",
	"format.optifine_entity": "OptiFine 实体",
	"format.optifine_entity.desc": "自定义 OptiFine 实体模型",
	"keys.mouse": "鼠标键 %0",
	"message.cleared_blank_faces.title": "空白面",
	"message.cleared_blank_faces.message": "Blockbench 发现 %0 没有任何纹理的立方体。你要删除那些元素吗？",
	"message.wireframe.enabled": "线框视图已启用",
	"message.wireframe.disabled": "线框视图已禁用",
	"dialog.convert_project.title": "转换项目",
	"dialog.create_texture.double_use": "保持多纹理占用",
	"dialog.model_stats.title": "模型统计",
	"dialog.model_stats.cubes": "块",
	"dialog.model_stats.locators": "定位器",
	"dialog.model_stats.groups": "分组",
	"dialog.model_stats.vertices": "顶点",
	"dialog.model_stats.faces": "面",
	"settings.username": "用户名",
	"settings.username.desc": "编辑会话的用户名",
	"settings.painting_grid": "绘画网格",
	"settings.painting_grid.desc": "在绘画模式下为纹理块显示网格",
	"action.convert_project": "转换项目",
	"action.convert_project.desc": "将转换当前项目格式以用于其他模型格式",
	"action.close_project": "关闭项目",
	"action.close_project.desc": "关闭当前项目",
	"action.export_bedrock": "导出 Bedrock 版几何",
	"action.export_bedrock.desc": "将模型导出为基岩版几何文件。",
	"action.save_project": "保存项目",
	"action.save_project.desc": "保存当前模型为项目文件",
	"action.save_project_as": "另存为项目",
	"action.save_project_as.desc": "将当前模型以项目文件的形式保存在其他位置",
	"action.export_over": "保存模型",
	"action.export_over.desc": "通过覆写文件来保存模型、纹理和动画",
	"action.add_locator": "添加定位器",
	"action.add_locator.desc": "添加新的定位器，以控制粒子、牵引等位置",
	"action.uv_turn_mapping": "转向映射",
	"action.uv_turn_mapping.desc": "将 UV 映射转 90 度",
	"action.remove_blank_faces": "移除空白面",
	"action.remove_blank_faces.desc": "删除所有选中的无纹理面",
	"web.download_app": "下载 App",
	"uv_editor.turned": "已转映射",
	"display.reference.crossbow": "拉开的弩",
	"dialog.settings.search_results": "搜索结果",
	"settings.animation_snap": "动画捕捉",
	"settings.animation_snap.desc": "动画时间轴中关键帧的默认捕捉间隔，单位为每秒帧数。这也可以根据动画进行更改。默认值为 24。",
	"action.import_optifine_part": "导入 OptiFine 部件",
	"action.import_optifine_part.desc": "为 OptiFine 导入一个实体部件模型",
	"data.locator": "定位器",
	"mode.start.no_recents": "最近未打开过模型文件",
	"panel.element": "元素",
	"panel.element.position": "位置",
	"panel.element.size": "尺寸",
	"panel.element.origin": "枢轴点",
	"panel.element.rotation": "旋转",
	"message.canvas_limit_error.title": "工作区限制错误",
	"message.canvas_limit_error.message": "无法正确执行此操作，因为此格式将工作区限制为 48 个单位。移动枢轴点以避免此情况。",
	"data.effect": "效果",
	"generic.name": "名称",
	"settings.recent_projects": "最近编辑项目数",
	"settings.recent_projects.desc": "最近编辑项目的最大显示数量",
	"settings.volume": "音量",
	"settings.volume.desc": "动画中声音效果的音量控制",
	"action.clear_timeline": "清除时间轴",
	"action.clear_timeline.desc": "清除时间轴中所有未选中的模型骨骼",
	"action.select_effect_animator": "动画效果",
	"action.select_effect_animator.desc": "打开时间轴以添加声音和粒子效果",
	"action.timeline_focus": "通道",
	"action.timeline_focus.desc": "选择要在时间轴中显示的动画通道",
	"timeline.particle": "粒子",
	"timeline.sound": "声音",
	"timeline.effects": "效果",
	"data.format": "格式",
	"format.optifine_part": "OptiFine Part",
	"format.optifine_part.desc": "用于 OptiFine 实体模型的 JPM",
	"action.reverse_keyframes": "反转关键帧",
	"action.reverse_keyframes.desc": "反转所选关键帧的顺序",
	"generic.help": "帮助",
	"message.removed_faces": "已经移除 %0 个面",
	"dialog.sketchfab_uploader.draft": "草稿",
	"action.slider_pos": "%0 轴移动",
	"action.slider_pos.desc": "在 %0 轴移动块",
	"action.slider_size": "%0 轴尺寸",
	"action.slider_size.desc": "在 %0 轴调整块的大小",
	"action.slider_rotation": "%0 轴旋转",
	"action.slider_rotation.desc": "绕 %0 轴旋转块",
	"action.slider_origin": "%0 轴向枢轴",
	"action.slider_origin.desc": "%0 轴向移动枢轴",
	"action.rotate_cw": "旋转 %0 +90",
	"action.rotate_cw.desc": "将选定元素绕 %0 轴旋转 90°",
	"action.rotate_ccw": "旋转 %0 -90",
	"action.rotate_ccw.desc": "将选定元素绕 %0 轴旋转 -90°",
	"action.flip": "%0 轴翻转",
	"action.flip.desc": "将所选块于 %0 轴翻转",
	"action.center": "%0 轴居中",
	"action.center.desc": "将所选块于 %0 轴居中",
	"action.bring_up_all_animations": "将所有修改后的动画放入时间轴",
	"panel.bone": "骨骼",
	"data.color": "颜色",
	"generic.export": "导出",
	"generic.none": "无",
	"status_bar.recording": "拍摄延时摄影",
	"message.add_to_palette": "添加到调色板",
	"message.size_modifiers": "按住 Ctrl 或 Shift 键操作以进行微调。",
	"message.timelapse_start": "延时摄影以启动",
	"message.timelapse_stop": "延时摄影已关闭",
	"message.import_palette.replace_palette": "切换旧调色板",
	"message.import_palette.threshold": "合并阈值",
	"dialog.timelapse.interval": "间隔（秒）",
	"dialog.timelapse.source": "来源",
	"dialog.timelapse.source.interface": "界面",
	"dialog.timelapse.source.locked": "锁定角度",
	"dialog.timelapse.destination": "目标文件夹",
	"layout.color.checkerboard": "透明背景",
	"layout.color.checkerboard.desc": "工作区和 UV 编辑器的背景",
	"layout.font.code": "代码字体",
	"layout.css": "自定义 CSS",
	"settings.category.paint": "颜料",
	"settings.deactivate_size_limit": "取消大小限制",
	"settings.deactivate_size_limit.desc": "取消模型格式的大小限制。警告：这可能导致无效模型。",
	"settings.brush_opacity_modifier": "笔刷不透明度",
	"settings.brush_opacity_modifier.desc": "使用手写笔时修改笔刷的不透明度",
	"settings.brush_size_modifier": "笔刷大小选择器",
	"settings.brush_size_modifier.desc": "使用手写笔时修改画笔的大小",
	"settings.brush_modifier.pressure": "笔触",
	"settings.brush_modifier.tilt": "倾斜",
	"category.color": "颜色",
	"action.import_theme": "导入主题",
	"action.export_theme": "导出主题",
	"action.export_theme.desc": "创建当前设置的主题文件",
	"action.slider_color_h": "色调",
	"action.slider_color_s": "饱和度",
	"action.slider_color_v": "值",
	"action.add_to_palette": "添加到调色板",
	"action.add_to_palette.desc": "将所选颜色添加到调色板",
	"action.import_palette": "导入调色板",
	"action.import_palette.desc": "导入配色文件",
	"action.export_palette": "导出调色板",
	"action.export_palette.desc": "将调色板导出为 .GPL 文件",
	"action.generate_palette": "生成调色板...",
	"action.generate_palette.desc": "从纹理生成调色板",
	"action.sort_palette": "排序调色板",
	"action.sort_palette.desc": "按颜色和亮度对调色板上所有的颜色进行排序",
	"action.timelapse": "延时视频...",
	"action.timelapse.desc": "录制建模过程的延时视频",
	"action.add_keyframe": "添加关键帧",
	"action.add_keyframe.desc": "添加关键帧到所选动画",
	"action.bring_up_all_animations.desc": "将所有修改后的动画置入到时间轴内",
	"timeline.timeline": "指令",
	"menu.palette.load.default": "默认",
	"generic.import": "导入",
	"settings.brush_modifier.none": "无",
	"action.export_entity": "导出 Bedrock 版实体",
	"action.export_entity.desc": "将模型导出为 Minecraft 基岩版的实体模型",
	"settings.highlight_cubes": "高亮显示块",
	"settings.highlight_cubes.desc": "高亮显示鼠标悬停或选择的块",
	"action.add_marker": "设置标记",
	"action.add_marker.desc": "设置一个时间轴点标记",
	"timeline.pre_effect_script": "脚本",
	"format.skin": "Minecraft 皮肤",
	"format.skin.desc": "编辑玩家和实体的皮肤",
	"message.sketchfab.setup_guide": "想学习如何在 Sketchfab 中设置模型？请阅读 %0",
	"dialog.skin.title": "创建 Minecraft 皮肤",
	"dialog.skin.model": "模型",
	"action.toggle_skin_layer": "切换皮肤叠层",
	"action.toggle_skin_layer.desc": "切换皮肤模型的帽子和衣服叠层",
	"action.gui_light": "GUI 光照",
	"action.gui_light.desc": "选择物品栏中物品的光照方式",
	"action.gui_light.side": "侧置光照",
	"action.gui_light.front": "前置光照",
	"action.move_keyframe_back": "向前移动关键帧",
	"action.move_keyframe_forth": "向后移动关键帧",
	"menu.help": "帮助",
	"menu.help.discord": "Discord 服务器",
	"menu.help.report_issue": "向开发者反馈问题",
	"menu.help.plugin_documentation": "插件 API 文档",
	"menu.help.search_action": "搜索并执行操作",
	"menu.help.donate": "捐赠",
	"menu.help.about": "关于...",
	"menu.preview.background.clipboard": "从剪贴板加载",
	"dialog.ignore": "忽略",
	"generic.unset": "未设置",
	"message.invalid_builtin_parent.title": "内置的父模型无效",
	"message.invalid_builtin_parent.message": "为了导出有效模型，已删除指向无效父模型“%0”的链接。",
	"dialog.resize_texture.fill": "填充",
	"dialog.resize_texture.fill.transparent": "透明",
	"dialog.resize_texture.fill.color": "颜色",
	"dialog.resize_texture.fill.repeat": "重复",
	"dialog.scale.element_pivot": "元素枢轴",
	"dialog.scale.selection_center": "选择中心",
	"dialog.create_gif.length_mode": "长度模式",
	"dialog.create_gif.length_mode.seconds": "秒",
	"dialog.create_gif.length_mode.frames": "帧数",
	"dialog.create_gif.length_mode.animation": "动画长度",
	"dialog.create_gif.length_mode.turntable": "旋转台旋转",
	"dialog.save_angle.projection": "投影",
	"dialog.save_angle.projection.perspective": "透视投影",
	"dialog.save_angle.projection.orthographic": "正射投影",
	"dialog.sketchfab_uploader.animations": "动画制作",
	"dialog.settings.theme": "主题",
	"settings.category.interface": "界面",
	"settings.preview_checkerboard": "预览网格",
	"settings.preview_checkerboard.desc": "修改预览网格的背景",
	"settings.uv_checkerboard": "UV 编辑器网格",
	"settings.uv_checkerboard.desc": "修改 UV 编辑器后的网格背景",
	"category.paint": "漆",
	"action.fill_mode.color_connected": "连接颜色",
	"action.draw_shape_type": "形状类型",
	"action.draw_shape_type.rectangle": "矩形",
	"action.draw_shape_type.rectangle_h": "矩形（空心）",
	"action.draw_shape_type.ellipse": "椭圆",
	"action.draw_shape_type.ellipse_h": "椭圆（空心）",
	"action.draw_shape_type.line": "直线",
	"action.mirror_painting": "镜像绘画",
	"action.mirror_painting.description": "在一边绘画像素的同时另一也会有同样的像素",
	"action.lock_alpha": "锁定 Alpha 通道",
	"action.lock_alpha.description": "锁定所有像素的透明度",
	"action.draw_shape_tool": "绘制形状",
	"action.draw_shape_tool.desc": "在纹理上绘制简单形状的工具",
	"action.export_gltf": "导出 glTF 模型",
	"action.export_gltf.desc": "将模型和动画导出为 glTF 文件以用于共享和渲染",
	"action.transform_space": "变换方向",
	"action.transform_space.desc": "元素和绑骨的默认变换方向",
	"action.transform_space.global": "全局",
	"action.transform_space.local": "自身",
	"action.toggle_camera_projection": "切换相机投影",
	"action.toggle_camera_projection.desc": "在透视和正视投影之间进行切换",
	"action.load_camera_angle": "摄影机角度：%0",
	"action.load_camera_angle.desc": "载入相机角度“%0”",
	"action.slider_face_tint": "色调指数",
	"action.slider_face_tint.desc": "设置当前面的色调指数。-1 表示未设置。",
	"menu.help.quickstart": "快速入门向导",
	"menu.help.developer": "开发者",
	"menu.help.developer.dev_tools": "打开开发工具",
	"menu.help.developer.reset_storage": "恢复全部默认设置",
	"menu.help.developer.reset_storage.confirm": "确定要重置 Blockbench 设置吗？这将删除所有自定义设置、键绑定和安装的插件。",
	"menu.help.developer.cache_reload": "缓存刷新",
	"menu.preview.orthographic": "正射投影",
	"menu.preview.save_angle": "保存相机角度...",
	"menu.preview.angle": "角度",
	"menu.preview.angle.initial": "初始角度",
	"menu.preview.maximize": "最大化",
	"uv_editor.copy_selection": "复制所选内容",
	"uv_editor.paste_selection": "粘贴所选内容",
	"uv_editor.copy_paste_tool.place": "放置",
	"uv_editor.copy_paste_tool.mirror_x": "镜像 X 轴",
	"uv_editor.copy_paste_tool.mirror_y": "镜像 Y 轴",
	"uv_editor.copy_paste_tool.rotate": "旋转90度",
	"dialog.project.modded_entity_version": "导出版本",
	"dialog.save_angle.position": "摄像机位置",
	"dialog.save_angle.target": "焦点",
	"dialog.skin.pose": "动作",
	"layout.color.frame": "窗框",
	"layout.color.frame.desc": "窗口的边框和标题栏",
	"settings.large_grid_size": "大网格大小",
	"settings.large_grid_size.desc": "大状网格的大小",
	"action.load_plugin_from_url": "从 URL 加载插件",
	"action.load_plugin_from_url.desc": "通过指定 URL 从服务器加载插件",
	"action.cube_counter.desc": "显示当前项目中元素数量和其他统计信息",
	"action.unlock_everything": "解锁全部",
	"action.unlock_everything.desc": "解锁大纲视图中的所有分组和元素。",
	"action.load_palette": "加载调色板",
	"action.load_palette.desc": "加载内置调色板预设之一",
	"action.toggle_locked": "锁定",
	"action.toggle_locked.desc": "切换所选元素是否被锁定",
	"action.apply_display_preset": "应用预设",
	"action.apply_display_preset.desc": "应用默认或自定义显示设置预设",
	"action.apply_display_preset.here": "应用于此槽位",
	"action.apply_display_preset.everywhere": "应用于所有槽位",
	"action.resolve_keyframe_expressions": "解析关键帧",
	"action.resolve_keyframe_expressions.desc": "解析选定关键帧的数学表达式",
	"action.fold_all_animations": "折叠所有动画",
	"menu.palette.load.empty": "无",
	"switches.lock": "锁定",
	"settings.render_sides": "渲染面",
	"settings.render_sides.desc": "选择要渲染的面",
	"settings.render_sides.auto": "自动",
	"settings.render_sides.front": "外面",
	"settings.render_sides.double": "内面与外面",
	"generic.enable": "启用",
	"generic.disable": "禁用",
	"generic.redacted": "已隐藏",
	"dialog.select_texture.import_all": "导入所有",
	"dialog.skin.layer_template": "纹理图层",
	"about.version.up_to_date": "已是最新",
	"about.version.update_available": "可用版本 %0",
	"settings.category.application": "应用",
	"settings.streamer_mode": "直播模式",
	"settings.streamer_mode.desc": "隐藏敏感信息，比如最近编辑的项目历史",
	"settings.automatic_updates": "自动更新",
	"settings.automatic_updates.desc": "自动下载新版本并使 Blockbench 保持最新",
	"action.rotation_space": "旋转的范围",
	"action.focus_on_selection": "选中对焦",
	"action.focus_on_selection.desc": "聚焦视觉到当前选中的内容",
	"action.jump_to_timeline_start": "转跳到动画起点",
	"action.jump_to_timeline_end": "转跳到动画终点",
	"menu.help.updating": "更新中（%0%）",
	"menu.help.update_failed": "更新失败",
	"menu.animation.loop.once": "播放一次",
	"menu.animation.loop.hold": "停止于最后一帧",
	"menu.animation.loop.loop": "循环播放",
	"interface.streamer_mode_on": "已启用直播模式",
	"generic.reset": "重置",
	"generic.restore": "恢复",
	"keys.mousewheel": "滚轮",
	"message.delete_animation.title": "删除动画",
	"message.delete_animation.message": "该动画已从 Blockbench 中移除。是否同时在已保存的文件中删除该动画？",
	"message.no_animation_to_import": "没有可导入的动画",
	"dialog.material_instances.title": "材质实例",
	"dialog.animation_import.title": "选择需要导入的动画",
	"dialog.create_texture.padding": "填充",
	"settings.fov": "视野",
	"settings.fov.desc": "相机视野。默认值 45",
	"settings.minify_bbmodel": "压缩项目文件",
	"settings.minify_bbmodel.desc": "将 .bbmodel 文件保存为单行",
	"action.edit_material_instances": "编辑材质实例",
	"action.edit_material_instances.desc": "编辑 Bedrock 版方块几何体的材质实例名称",
	"action.save_all_animations": "保存所有动画",
	"action.save_all_animations.desc": "保存所有当前加载的动画",
	"action.keyframe_interpolation": "插值",
	"action.keyframe_interpolation.desc": "选择插值的模式",
	"action.keyframe_interpolation.linear": "线性",
	"action.keyframe_interpolation.catmullrom": "平滑",
	"action.timeline_focus.hide_empty": "隐藏空通道",
	"menu.file.preferences": "首选项",
	"menu.animation.blend_weight": "混合权重",
	"menu.animation.save": "保存",
	"menu.animation.properties": "属性...",
	"menu.animation.file": "文件",
	"menu.animation.snapping": "吸附",
	"menu.animation.open_location": "打开文件所在位置",
	"panel.keyframe.add_data_point": "添加关键帧数据点",
	"panel.keyframe.remove_data_point": "移除数据点",
	"panel.keyframe.pre": "前",
	"panel.keyframe.post": "后",
	"generic.all": "全部",
	"message.small_face_dimensions.title": "不兼容的界面维度",
	"message.small_face_dimensions.message": "选择包含在一个方向上小于 1 个单位的面。箱型 UV 映射系统将低于该阈值的任何面视为 0 像素宽。 因此这些面上的纹理可能无法正常工作。",
	"message.small_face_dimensions.face_uv": "当前格式支持逐面 UV 贴图，可以处理较小的面尺寸。右键单击受影响的立方体，并将“UV 模式”更改为“逐面 UV”。",
	"dialog.plugins.outdated_client": "需要新版本的 Blockbench",
	"dialog.plugins.outdated_plugin": "插件已过时，不适用于当前版本的 Blockbench",
	"settings.motion_trails": "运动轨迹",
	"settings.motion_trails.desc": "在动画编辑器中显示运动轨迹",
	"settings.antialiasing": "抗锯齿",
	"settings.antialiasing.desc": "在预览启用抗锯齿。重新启动 Blockbench 以应用更改",
	"action.timeline_frame_back": "上一个关键帧",
	"action.timeline_frame_forth": "下一个关键帧",
	"panel.bone.ik": "反向运动（实验功能）",
	"settings.particle_tick_rate": "粒子频率",
	"settings.particle_tick_rate.desc": "粒子效应的速率，单位为每秒。默认值 30",
	"action.lock_motion_trail": "锁定运动轨迹",
	"action.lock_motion_trail.desc": "锁定运动轨迹到当前选择的分组",
	"menu.animation_file.unload": "卸载动画文件",
	"data.null_object": "空目标",
	"status_bar.toggle_sidebar": "显示侧边栏",
	"message.load_plugin_failed.title": "插件加载失败",
	"message.load_plugin_failed.message": "确保插件的基本文件名与 Plugin.register() 中定义的插件 ID “%0”匹配。",
	"dialog.project.uv_mode": "UV 模式",
	"dialog.project.uv_mode.box_uv": "箱型 UV",
	"dialog.project.uv_mode.face_uv": "逐面 UV",
	"dialog.project.texture_size": "纹理分辨率",
	"dialog.animation_export.title": "选择要导出的动画",
	"dialog.create_texture.rearrange_uv": "重新排列 UV",
	"layout.color.subtle_text": "次要文字",
	"layout.color.subtle_text.desc": "对比度较低的文本颜色",
	"settings.interface_scale": "界面尺寸",
	"settings.interface_scale.desc": "Blockbench 界面缩放比",
	"settings.background_rendering": "背景渲染",
	"settings.background_rendering.desc": "窗口失去焦点时更新预览",
	"settings.ctrl_shift_size": "Ctrl + Shift 移动距离",
	"settings.ctrl_shift_size.desc": "同时按住 Ctrl 和 Shift 时立方体移动的距离",
	"settings.hardware_acceleration": "硬件加速",
	"settings.hardware_acceleration.desc": "将渲染任务分配给显卡",
	"action.explode_skin_model": "皮肤模型分解视图",
	"action.explode_skin_model.desc": "切换到分解视图，便于编辑被覆盖的面",
	"action.export_minecraft_skin": "导出 Minecraft 皮肤",
	"action.export_minecraft_skin.desc": "将 Minecraft 皮肤导出为 PNG 纹理",
	"action.add_null_object": "添加空目标",
	"action.add_null_object.desc": "添加新的空对象",
	"action.animated_texture_frame": "动态纹理帧",
	"action.animated_texture_frame.desc": "设置当前帧使用的动态纹理",
	"action.export_animation_file": "导出动画...",
	"action.export_animation_file.desc": "将选定的动作导出至新文件中",
	"action.timeline_graph_editor": "切换图像编辑器",
	"action.timeline_graph_editor.desc": "切换时间轴的图像编辑器视图和关键帧视图",
	"menu.file.recent.clear": "清空最近的文件",
	"switches.shade": "阴影",
	"generic.share": "分享",
	"dates.minute": "%0 分钟",
	"dates.minutes": "%0 分钟",
	"dates.hour": "%0 小时",
	"dates.hours": "%0 小时",
	"dates.day": "%0 天",
	"dates.days": "%0 天",
	"dates.week": "%0 周",
	"dates.weeks": "%0 周",
	"dates.year": "%0 年",
	"dates.years": "%0 年",
	"message.installed_plugin": "%0 插件安装成功",
	"message.installed_plugin_fail": "%0 插件安装失败",
	"dialog.share_model.title": "分享模型",
	"dialog.share_model.expire_time": "过期时间",
	"dialog.share_model.failed": "上传模型失败",
	"action.import_java_block_model": "添加 Java 版方块/物品模型",
	"action.import_java_block_model.desc": "从 Json 文件将 Minecraft Java 版方块/物品模型添加到当前模型",
	"action.share_model": "分享...",
	"action.share_model.desc": "生成一个短链接来分享您的模型",
	"action.import_project": "导入项目",
	"action.import_project.desc": "从其他 .bbmodel 项目文件导入到当前项目",
	"dialog.toolbar_edit.hidden_tools": "某些工具被自动隐藏，因为在当前项目、格式、或其他因素下不可用。",
	"settings.camera_near_plane": "摄像机靠近平面",
	"settings.camera_near_plane.desc": "物体渲染的相机的最小距离。较高的值会减少 Z-fighting。默认值为 1。",
	"mode.start.keymap_preference.desc": "如果您是 Blockbench 的新手且曾使用其他 3D 程序，您可以选择一个键盘映射以使您的转换更容易。稍后可在设置中更改键盘映射或单个键绑定。",
	"message.load_keymap": "你确定要加载此键盘映射吗？这会覆盖你当前的键位绑定。",
	"message.keymap_loaded": "已加载键盘映射",
	"dialog.convert_project.current_format": "当前格式",
	"dialog.create_texture.rearrange_uv.desc": "创建一个新的 UV 排列，以在材质上显示每一个面",
	"dialog.create_texture.power.desc": "将自动材质大小锁定为 2 的几次幂，例如 64 或 128。以适应某些渲染器",
	"dialog.create_texture.double_use.desc": "如果两个元素已经分配了相同的 UV 空间，请在新贴图中保持这种方式",
	"dialog.create_texture.padding.desc": "在模板的各个部分之间填充一个小空格",
	"dialog.create_texture.resolution.desc": "材质的宽度和高度",
	"dialog.create_gif.color": "背景色",
	"dialog.save_angle.zoom": "缩放",
	"dialog.skin.variant": "变体",
	"dialog.flip_animation.info": "对立的骨骼由其名称中的关键字“left”和“right”标识。",
	"dialog.export_private_settings.title": "隐私设置",
	"dialog.export_private_settings.message": "您的文件包含下列隐私信息：**%0**。如果您计划与其他人共享文件，请忽略这些值。",
	"dialog.export_private_settings.keep": "保持",
	"settings.timecode_frame_number": "以帧率显示时间码",
	"settings.timecode_frame_number.desc": "将时间线中的分数时间码显示为帧号而不是秒",
	"settings.animation_sample_rate": "动画采样率",
	"settings.animation_sample_rate.desc": "相应格式本身不支持的曲线的每秒采样率",
	"keybind.preview_zoom": "缩放视图",
	"action.gradient_tool": "渐变工具",
	"action.gradient_tool.desc": "在纹理上创建颜色渐变",
	"action.import_settings": "导入设置",
	"action.import_settings.desc": "导入 .bbsettings 文件",
	"action.export_settings": "导出设置",
	"action.export_settings.desc": "导出 Blockbench 设置文件 .bbsettings",
	"action.load_keymap": "加载键盘映射",
	"action.load_keymap.default": "默认（触控板/鼠标）",
	"action.load_keymap.mouse": "默认（鼠标）",
	"action.load_keymap.default.desc": "默认 Blockbench 键绑定，具有针对笔记本电脑触控板使用而优化的视口导航控件",
	"action.load_keymap.mouse.desc": "默认 Blockbench 键绑定，视口导航绑定到鼠标中键",
	"action.load_keymap.blender.desc": "适用于 Blender 用户的键位绑定",
	"action.load_keymap.cinema4d.desc": "适用于 Cinema 4D 用户的键位绑定",
	"action.load_keymap.maya.desc": "适用于 Autodesk Maya 用户的键位绑定",
	"action.import_keymap": "导入键位绑定设置文件",
	"action.import_keymap.desc": "导入 .bbkeymap 键位绑定设置文件",
	"action.export_keymap": "导出键位绑定设置文件",
	"action.export_keymap.desc": "导出键位绑定设置文件为 .bbkeymap 文件",
	"action.edit_history": "编辑历史...",
	"action.edit_history.desc": "查看编辑历史和重做或撤回操作",
	"action.group_elements": "分组元素",
	"action.group_elements.desc": "将所选元素包装到一个新分组中",
	"action.unfold_groups": "展开所有分组",
	"action.unfold_groups.desc": "展开大纲下所有分组",
	"action.edit_bedrock_binding": "编辑绑定...",
	"action.edit_bedrock_binding.desc": "更改几何绑定到的骨骼",
	"action.pick_screen_color": "选取屏幕颜色",
	"action.pick_screen_color.desc": "从屏幕中选取颜色",
	"action.view_mode": "显示模式",
	"action.view_mode.desc": "切换显示模式",
	"action.view_mode.textured": "纹理",
	"action.view_mode.solid": "实体",
	"action.view_mode.wireframe": "线框",
	"action.toggle_sidebars": "切换侧边栏",
	"action.toggle_sidebars.desc": "启用或禁用侧边栏",
	"action.set_animation_end": "设置动画结束点",
	"action.set_animation_end.desc": "将选定动画的结束设置为当前时间轴时间",
	"action.flip_animation": "翻转动画",
	"action.flip_animation.desc": "通过将选定的关键帧复制到模型的另一侧来翻转动画的一部分",
	"action.graph_editor_zero_line": "包括零线",
	"action.graph_editor_zero_line.desc": "图形编辑器是否始终在视图中包含零线",
	"menu.texture.render_mode": "渲染模式",
	"menu.texture.render_mode.emissive": "发光",
	"menu.texture.render_mode.layered": "图层",
	"menu.preview.angle.edit": "编辑角度...",
	"menu.animation.start_delay": "启动延迟",
	"menu.animation.loop_delay": "循环延迟",
	"menu.animation.flip_keyframes": "翻转关键帧",
	"menu.mobile_keyboard.disable_all": "禁用所有",
	"panel.keyframe.toggle_uniform_scale": "切换统一比例",
	"camera_angle.common_isometric_right": "等距右（2:1）",
	"camera_angle.common_isometric_left": "等距左（2:1）",
	"camera_angle.true_isometric_right": "真等距右（30°）",
	"camera_angle.true_isometric_left": "真等距左（30°）",
	"menu.help.wiki": "Blockbench 维基",
	"settings.update_to_prereleases": "更新至预发布版",
	"settings.update_to_prereleases.desc": "自动更新至 beta 版本的 Blockbench 以测试新功能。预发布版本可能不稳定，如果您依赖 Blockbench 工作或其他重要项目，请不要启用此选项。",
	"data.separator.spacer": "间隔",
	"data.separator.linebreak": "换行符",
	"data.setting": "设置",
	"generic.select_all": "选择全部",
	"generic.select_none": "无选择",
	"projects.new_tab": "新标签页",
	"projects.close_tab": "关闭标签页",
	"message.invalid_format.title": "无效的格式",
	"message.invalid_format.message": "此模型以“%0”格式制作，并在你的 Blockbench 中不可用。你需要安装特定插件才能正确打开。",
	"message.invalid_link": "无效或过期的模型链接",
	"message.default_textures.current": "当前路径",
	"message.update_after_restart": "此次更新将会在软件重启后完成",
	"message.copy_paste_tool_viewport": "此工具仅能在 2D 编辑器中使用",
	"dialog.project.shadow_size": "阴影大小",
	"dialog.find_replace.target": "目标",
	"dialog.find_replace.target.element_names": "元素名称",
	"dialog.find_replace.target.group_names": "分组名称",
	"dialog.find_replace.target.animation_names": "动画名称",
	"dialog.find_replace.target.keyframe_values": "关键帧数值",
	"dialog.find_replace.find": "查找",
	"dialog.find_replace.replace": "替换",
	"dialog.find_replace.regex": "正则表达式",
	"dialog.add_primitive.shape": "形状",
	"dialog.add_primitive.shape.circle": "圆形",
	"dialog.add_primitive.shape.tube": "圆筒",
	"dialog.add_primitive.shape.cone": "圆锥",
	"dialog.add_primitive.shape.cylinder": "圆柱",
	"dialog.add_primitive.shape.sphere": "球形",
	"dialog.add_primitive.shape.torus": "圆环",
	"dialog.add_primitive.shape.cube": "方形",
	"dialog.add_primitive.shape.pyramid": "棱锥",
	"dialog.add_primitive.diameter": "直径",
	"dialog.add_primitive.height": "高度",
	"dialog.add_primitive.sides": "段数",
	"dialog.add_primitive.minor_diameter": "厚度",
	"dialog.add_primitive.minor_sides": "次要侧面",
	"dialog.create_texture.combine_polys": "合并面",
	"dialog.create_texture.combine_polys.desc": "将共同面合并至同一个 UV",
	"dialog.model_stats.meshes": "网格",
	"dialog.export_private_settings.omit": "忽略",
	"layout.select": "选择",
	"layout.options": "选项",
	"layout.color": "配色方案",
	"layout.documentation": "文档",
	"layout.color.bright_ui_text": "高亮的 UI 文本",
	"layout.color.bright_ui_text.desc": "高亮背景上的文本",
	"layout.name": "名称",
	"layout.author": "作者",
	"settings.dialog.desc": "显示“%0”对话框",
	"settings.export_empty_groups": "导出空分组",
	"settings.export_empty_groups.desc": "导出中包含空的分组",
	"category.separators": "分隔符",
	"keybind.preview_area_select": "选择区域",
	"action.color_erase_mode": "擦除模式",
	"action.color_erase_mode.desc": "启用擦除模式后，填充和矩形等工具会删除颜色而不是添加颜色",
	"action.open_from_link": "从链接打开模型...",
	"action.open_from_link.desc": "从 blckbn.ch 链接打开模型",
	"action.import_obj": "导入 OBJ 模型",
	"action.import_obj.desc": "以网格形式导入 OBJ 模型",
	"action.add_plugin": "安装插件",
	"action.add_plugin.desc": "通过动作控制安装插件",
	"action.remove_plugin": "卸载插件",
	"action.remove_plugin.desc": "通过动作控制卸载插件",
	"action.add_mesh": "添加网格",
	"action.add_mesh.desc": "添加一个新的网格形状",
	"action.add_texture_mesh": "添加纹理网格",
	"action.add_texture_mesh.desc": "添加一个新的纹理网格",
	"action.find_replace": "查找/替换...",
	"action.find_replace.desc": "查找并替换部分名字",
	"action.hide_everything_except_selection": "仅显示所选项",
	"action.hide_everything_except_selection.desc": "切换除选定元素之外的所有元素的可见性",
	"action.transform_space.normal": "正常",
	"action.selection_mode": "选区模式",
	"action.selection_mode.desc": "更改在视图中选择元素的方式",
	"action.selection_mode.object": "物体",
	"action.selection_mode.face": "面",
	"action.selection_mode.vertex": "顶点",
	"action.create_face": "创建面或边",
	"action.create_face.desc": "在选中的顶点间新建面或边",
	"action.convert_to_mesh": "转换成网格",
	"action.convert_to_mesh.desc": "转换使选中的元素成网格",
	"action.invert_face": "反转面",
	"action.invert_face.desc": "反转选中的面使其面向相反方向",
	"action.extrude_mesh_selection": "拉伸选区",
	"action.extrude_mesh_selection.desc": "拉伸选中部分的网格",
	"action.loop_cut": "环形切割",
	"action.loop_cut.desc": "在选定的边上循环分割网格",
	"action.merge_meshes": "合并网格",
	"action.merge_meshes.desc": "合并多个网格为一个",
	"action.keyframe_uniform": "均匀缩放",
	"action.keyframe_uniform.desc": "在选定的关键帧上启用统一缩放",
	"menu.locator.ignore_inherited_scale": "忽略继承的比例",
	"menu.texture.elements": "应用到元素",
	"uv_editor.transparent_face": "透明面",
	"display.pose_angle": "姿势角度（仅用于预览）",
	"data.mesh": "网格",
	"dialog.create_texture.type": "类型",
	"dialog.create_texture.type.blank": "空白",
	"dialog.create_texture.type.template": "纹理模板",
	"dialog.create_texture.type.color_map": "纯色模板",
	"dialog.sketchfab_uploader.suggested_tags": "建议标签",
	"dialog.sketchfab_uploader.category": "类别",
	"dialog.sketchfab_uploader.category2": "类别2",
	"layout.restore_backup": "您的自定义主题“%0”已被覆盖。点击这里恢复它。",
	"layout.borders": "边框",
	"action.fill_mode.element": "元素",
	"action.inset_mesh_selection": "插入选择",
	"action.inset_mesh_selection.desc": "插入网格的选定部分",
	"action.dissolve_edges": "溶解边",
	"action.dissolve_edges.desc": "溶解网格中的选定边并合并它们划分的面",
	"action.split_mesh": "分割网格",
	"action.split_mesh.desc": "将网格的选定面拆分为新网格",
	"action.merge_vertices": "合并顶点",
	"action.merge_vertices.desc": "将所选顶点合并到第一个选定顶点的位置",
	"action.view_mode.normal": "面朝向",
	"action.snap_uv_to_pixels": "将 UV 捕捉到像素",
	"action.snap_uv_to_pixels.desc": "将选定的 UV 顶点捕捉到像素网格",
	"menu.file.import.import_open_project": "导入打开项目",
	"menu.help.unlock_projects": "解锁全部项目",
	"status_bar.selection.faces": "%0 面",
	"status_bar.selection.vertices": "%0 点",
	"message.merged_vertices": "在 %1 个位置找到并合并 %0 个顶点",
	"settings.vertex_merge_distance": "顶点合并距离",
	"settings.vertex_merge_distance.desc": "使用按距离合并的顶点的距离",
	"settings.show_only_selected_uv": "仅显示选中的 UV",
	"settings.show_only_selected_uv.desc": "默认情况下，仅在 UV 编辑器中显示选定的 UV 面",
	"action.merge_vertices.merge_all": "合并全部",
	"action.merge_vertices.merge_all_in_center": "在中心合并所有",
	"action.merge_vertices.merge_by_distance": "按距离合并",
	"action.merge_vertices.merge_by_distance_in_center": "按中心距离合并",
	"action.uv_rotate_left": "向左旋转 UV",
	"action.uv_rotate_left.desc": "逆时针旋转所选 UV 面",
	"action.uv_rotate_right": "向右旋转 UV",
	"action.uv_rotate_right.desc": "顺时针旋转所选 UV 面",
	"menu.uv.display_uv": "显示 UV",
	"menu.uv.display_uv.selected_faces": "所选面",
	"menu.uv.display_uv.selected_elements": "所有面",
	"menu.uv.display_uv.all_elements": "所有元素的所有面",
	"menu.paste.face": "UV 面",
	"menu.paste.mesh_selection": "网格选择",
	"menu.paste.outliner": "元素",
	"uv_editor.show_all_faces": "显示所有面",
	"uv_editor.show_selected_faces": "显示选定的面",
	"status_bar.selection.edges": "%0 条边",
	"action.selection_mode.edge": "边",
	"message.cannot_re_import.title": "无法重新导入模型",
	"message.cannot_re_import.message": "导出的模型格式无法再次导入 Blockbench。请确保将模型另存为项目文件。",
	"generic.default": "默认",
	"units.pixels_per_meter": "%0 像素/米",
	"mode.pose": "姿势",
	"modifier_actions.resize_both_sides": "在两个方向上调整大小",
	"modifier_actions.resize_one_side": "在一个方向上调整大小",
	"modifier_actions.draw_line": "绘制线条",
	"modifier_actions.drag_without_snapping": "拖动但不对齐",
	"modifier_actions.stretch_keyframes": "拉伸关键帧",
	"modifier_actions.resize_background": "调整背景大小",
	"modifier_actions.select_multiple": "选择多个",
	"modifier_actions.select_range": "选择范围",
	"modifier_actions.drag_to_duplicate": "拖动复制",
	"modifier_actions.uniform_scaling": "等比缩放",
	"modifier_actions.snap_direction": "捕捉方向",
	"message.no_valid_elements": "未选择有效元素...",
	"dialog.add_primitive.shape.plane": "平面",
	"dialog.save_angle.rotation_mode": "旋转模式",
	"dialog.save_angle.rotation": "旋转",
	"dialog.save_angle.fov": "视野",
	"settings.hide_tab_bar": "自动隐藏标签栏",
	"settings.hide_tab_bar.desc": "仅打开一个选项卡时隐藏标签栏",
	"settings.status_bar_modifier_keys": "建议状态栏中的修改键",
	"settings.status_bar_modifier_keys.desc": "在状态栏中显示上下文感知的建议更改",
	"settings.ground_plane": "接地层",
	"settings.ground_plane.desc": "在模型下面显示接地层",
	"settings.preview_paste_behavior": "默认预览粘贴行为",
	"settings.preview_paste_behavior.desc": "在编辑模式下将内容添加到预览的行为",
	"settings.preview_paste_behavior.always_ask": "始终询问",
	"action.new_window": "新窗口",
	"action.new_window.desc": "打开新的 Blockbench 窗口",
	"action.export_collada": "导出 Collada 模型（dae）",
	"action.export_collada.desc": "以 dae 格式导出模型和动画以用于其他 3D 软件",
	"action.paint_mode_uv_overlay": "UV 覆盖",
	"action.paint_mode_uv_overlay.desc": "在绘画模式下以覆盖形式显示 UV 贴图",
	"action.bake_animation_into_model": "烘焙动画姿态到模型",
	"action.bake_animation_into_model.desc": "将当前显示的动画帧复制到模型中。只应用旋转和位置，忽略缩放。",
	"action.keyframe_interpolation.step": "步",
	"action.set_ik_target": "设置 IK 目标",
	"action.set_ik_target.desc": "通过反选将这个空对象应用到目标骨骼",
	"menu.action_control.type.tab": "标签",
	"menu.action_control.type.angle": "镜头角度",
	"menu.action_control.recent_in_streamer_mode": "确定？流媒体模式已启用",
	"menu.action_control.recent_in_streamer_mode.desc": "您确定要显示最近的模型吗？",
	"menu.tools": "工具",
	"menu.file.recent.more": "查看更多内容...",
	"menu.null_object.lock_ik_target_rotation": "锁定选定目标旋转",
	"menu.animation_file.import_remaining": "导入剩余的动画文件",
	"edit.loop_cut.offset": "偏移",
	"edit.extrude_mesh_selection.extend": "扩展",
	"cube.color.pink": "粉色",
	"cube.color.silver": "银色",
	"dialog.plugins.offline": "没有网络连接",
	"dialog.create_texture.pixel_density": "像素密度",
	"dialog.create_texture.pixel_density.desc": "纹理的像素密度，以像素/米为单位。 纹理贴图的大小可能会因元素的数量和大小而异。",
	"panel.skin_pose": "姿势",
	"panel.skin_pose.none": "无",
	"panel.skin_pose.natural": "自然",
	"panel.skin_pose.walking": "步行",
	"panel.skin_pose.crouching": "下蹲",
	"panel.skin_pose.sitting": "坐下",
	"panel.skin_pose.jumping": "跳跃",
	"panel.skin_pose.aiming": "瞄准",
	"edit.loop_cut.direction": "方向",
	"data.texture_mesh": "纹理网格",
	"generic.left": "左侧",
	"generic.right": "右侧",
	"mode.start.quick_setup": "快速设置",
	"mode.start.keymap": "轮廓",
	"mode.start.quick_setup.more_themes": "更多...",
	"dialog.resize_texture.animation_frames": "动画帧",
	"dialog.export_emission_map.title": "导出动画",
	"dialog.export_emission_map.format": "格式",
	"dialog.export_emission_map.format.luminance": "亮度",
	"dialog.export_emission_map.format.luminance_inverted": "亮度反转",
	"dialog.export_emission_map.format.colors": "颜色",
	"dialog.export_emission_map.threshold": "透明度阈值",
	"dialog.export_emission_map.round_up": "向上取舍 %0 到 %1",
	"dialog.export_emission_map.flip_y": "翻转Y轴",
	"dialog.select.type": "元素类型",
	"dialog.create_texture.max_edge_angle": "边角阈值",
	"dialog.create_texture.max_edge_angle.desc": "两个面之间仍将被组合的最大角度",
	"dialog.create_texture.max_island_angle": "岛屿的最大倾斜角度",
	"dialog.create_texture.max_island_angle.desc": "同一个 UV 贴图可以组合的最大角度",
	"settings.mobile_panel_side": "移动面板",
	"settings.mobile_panel_side.desc": "选择竖屏使用 Blockbench 时屏幕面板的位置",
	"settings.obj_face_export_mode": "OBJ 面导出模式",
	"settings.obj_face_export_mode.desc": "选择让 OBJ 导出器将所有面转换为 tris 或 quads",
	"settings.obj_face_export_mode.both": "默认",
	"settings.obj_face_export_mode.tris": "转换为 Tris",
	"settings.obj_face_export_mode.quads": "转换为 Quads",
	"action.seam_tool": "缝隙连接工具",
	"action.seam_tool.desc": "用于定义网格边缘上的 UV 接缝的工具",
	"action.resolve_group": "解析分组",
	"action.resolve_group.desc": "解析分组，同时将其子项保留在同一位置",
	"action.move_to_group": "移动至",
	"action.move_to_group.desc": "将所选元素移至其他大纲视图组",
	"action.select_seam": "选择 UV 接缝",
	"action.select_seam.desc": "为所选边缘选择 UV 接缝模式",
	"action.select_seam.auto": "自动",
	"action.select_seam.join": "加入",
	"action.select_seam.divide": "分离",
	"action.adjust_brightness_contrast": "调整亮度和对比度...",
	"action.adjust_brightness_contrast.desc": "调整所选纹理的亮度和对比度",
	"action.adjust_saturation_hue": "调整饱和度和色调...",
	"action.adjust_saturation_hue.desc": "调整所选纹理的饱和度和色调",
	"action.invert_colors": "反转颜色",
	"action.invert_colors.desc": "反转所选纹理的所有颜色",
	"action.adjust_curves": "调整曲线...",
	"action.adjust_curves.desc": "调整所选纹理的亮度曲线",
	"action.flip_texture_x": "水平翻转纹理",
	"action.flip_texture_y": "垂直翻转纹理",
	"action.resize_texture": "调整纹理大小...",
	"action.view_mode.uv": "UV 预览",
	"action.append_to_template": "向模板追加元素...",
	"action.append_to_template.desc": "将选中的元素添加到纹理模板",
	"action.move_texture_with_uv": "使用 UV 移动纹理",
	"action.move_texture_with_uv.desc": "拖动 UV 面时移动面的纹理",
	"action.timeline_setups": "时间线设置",
	"action.save_timeline_setup": "保存时间线设置...",
	"action.save_timeline_setup.desc": "保存当前选定的动画师和频道的预设",
	"menu.texture": "纹理",
	"menu.texture.render_mode.default": "默认",
	"menu.texture.merge_onto_texture": "合并到上方的纹理上",
	"menu.animation.unload": "卸载",
	"panel.timeline": "时间线",
	"action.pan_tool": "平移工具",
	"action.pan_tool.desc": "在视口和纹理编辑器中导航的工具",
	"mode.start.recent.favorite": "标记为收藏",
	"mode.start.info": "信息",
	"mode.start.target": "目标",
	"mode.start.start": "开始",
	"mode.start.create_new": "创建新模型",
	"mode.start.format.informations": "你知道吗：",
	"mode.start.format.resources": "资源：",
	"format.free.info.meshes": "在此格式中，您可以使用立方体和自定义形状的网格创建 low poly 模型。",
	"format.free.info.limitation": "模型无法加载到需要特殊格式的游戏中，例如 Minecraft。",
	"format.skin.info.skin": "此格式旨在创建 Minecraft 皮肤和实体纹理。",
	"format.skin.info.model": "无法更改模型。要对模型进行更改，请先通过**文件**>**转换项目**转换为其他格式。",
	"format.java_block.info.rotation": "每个元素的旋转限制为 22.5°，且仅单个轴可旋转",
	"format.java_block.info.size": "该模型大小限制为 3x3x3 块。显示设置可以使物品模型更大",
	"format.java_block.info.animation": "原版 Minecraft 不支持此格式动画。如果你正在创建一个模组，则可使用 GeckoLib 制作模型动画。如果没有，制作动画的唯一方法是使用命令或动画纹理切换模型。",
	"format.bedrock.info.textures": "每个模型只能有一个纹理",
	"format.bedrock_block": "Bedrock 版方块",
	"format.bedrock_block.desc": "Bedrock 版方块模型",
	"format.modded_entity.info.integer_size": "单个立方体的大小仅限于整数。",
	"format.modded_entity.info.format": "模型是用 Java 代码编写的，而不是像所有其他 Blockbench 导出格式那样的专用数据结构。",
	"format.optifine_entity.info.optifine_required": "未安装 OptiFine 的用户将看不到该模型。",
	"format.optifine_entity.info.pivots": "骨骼枢轴被锁定，因此最好不要触碰它们。",
	"format_category.low_poly": "低多边形",
	"format_category.minecraft": "Minecraft",
	"format_category.other": "其他",
	"format_category.loaders": "加载程序",
	"message.recover_backup.recover": "恢复",
	"message.invalid_characters.title": "无效路径",
	"message.invalid_characters.message": "导入文件的路径包含无效字符、大写字母或空格。 支持的字符有：%0",
	"dialog.share_model.thumbnail": "缩略图",
	"dialog.skin.high_res_texture": "请注意，具有所选分辨率的皮肤将无法作为常规 Minecraft 皮肤使用。 选择较低的分辨率。",
	"settings.allow_display_slot_mirror": "允许镜像副手栏",
	"settings.allow_display_slot_mirror.desc": "允许对 Java 版项目模型的副手栏行镜像。 警告：此选项适用于 Minecraft 1.14 或更早版本或特殊情况。",
	"action.switch_tabs": "切换选项卡",
	"action.switch_tabs.desc": "在打开的选项卡之间循环。 按住 shift 以反方向循环。",
	"action.unselect_all": "取消选择",
	"action.save_palette": "保存调色板...",
	"action.save_palette.desc": "将当前调色板保存在 Blockbench 中供以后使用",
	"action.keyframe_column_create": "创建关键帧列",
	"action.keyframe_column_create.desc": "如果它们已经具有关键帧，将时间轴中的所有通道按当前时间进行关键帧",
	"action.keyframe_column_select": "选择关键帧列",
	"action.keyframe_column_select.desc": "沿播放键下方的列，选择时间轴中的所有关键帧",
	"menu.uv": "UV",
	"menu.keyframe": "关键帧",
	"menu.palette.load.update": "更新调色板",
	"menu.palette.load.update.desc": "用当前 Blockbench 调色板的颜色更新此调色板",
	"menu.timeline_marker.set_time": "设置时间...",
	"uv_editor.scale_uv": "缩放 UV",
	"action.preview_scene": "预览场景",
	"action.preview_scene.desc": "更改模型预览场景",
	"preview_scene.minecraft_overworld": "主世界",
	"preview_scene.minecraft_nether": "下界",
	"preview_scene.minecraft_end": "末地",
	"dialog.project.modded_entity_flip_y": "Y轴翻转",
	"preview_scene.studio": "工作室",
	"format.image": "图像",
	"modifier_actions.set_copy_source": "设置复制源",
	"message.load_images.title": "加载图像",
	"message.load_images.edit_image": "编辑图像",
	"dialog.add_primitive.align_edges": "对齐边缘",
	"dialog.flip_animation.show_in_timeline": "在时间轴中显示修改后的骨骼",
	"settings.default_cube_size": "默认方块大小",
	"settings.default_cube_size.desc": "创建新立方体时设置默认立方体大小",
	"settings.uniform_keyframe": "统一关键帧比例",
	"settings.uniform_keyframe.desc": "默认将缩放关键帧设置为统一缩放",
	"settings.nearest_rectangle_select": "矩形选择：最近的边",
	"settings.nearest_rectangle_select.desc": "将矩形选择捕捉到最近的像素边缘，就像在 GIMP 中一样，而不是整个像素。",
	"settings.pick_color_opacity": "选择颜色不透明度",
	"settings.pick_color_opacity.desc": "使用拾色器选择颜色不透明度并将其设置为画笔不透明度",
	"settings.paint_with_stylus_only": "仅使用触控笔绘画",
	"settings.paint_with_stylus_only.desc": "仅使用触控笔进行绘画、保留鼠标或触摸输入进行导航。",
	"action.copy_brush_mode": "复制画笔模式",
	"action.copy_brush_mode.copy": "复制",
	"action.copy_brush_mode.pattern": "图案",
	"action.copy_brush_mode.sample": "样本",
	"action.brush_shape": "画笔形状",
	"action.brush_shape.square": "方形",
	"action.brush_shape.circle": "圆形",
	"action.blend_mode": "混合模式",
	"action.blend_mode.default": "默认",
	"action.blend_mode.set_opacity": "设置不透明度",
	"action.blend_mode.color": "颜色",
	"action.blend_mode.behind": "背面",
	"action.blend_mode.multiply": "相乘",
	"action.blend_mode.divide": "分割",
	"action.blend_mode.add": "添加",
	"action.blend_mode.subtract": "相减",
	"action.blend_mode.screen": "屏幕",
	"action.blend_mode.overlay": "覆盖",
	"action.blend_mode.hard_light": "强光",
	"action.blend_mode.difference": "差异",
	"action.copy_brush": "复制画笔",
	"action.copy_brush.desc": "使用笔刷来复制纹理的一部分或绘制图案。按住 Ctrl 并点击以选择复制源。",
	"action.validator_window": "查看模型问题...",
	"action.validator_window.desc": "打开验证器，列出当前模型的问题。",
	"action.cancel_gif": "取消 GIF",
	"menu.text_edit.copy_vector": "复制向量",
	"menu.brush_presets.dialog": "画笔预设...",
	"menu.brush_presets.pixel_brush": "像素画笔",
	"menu.brush_presets.smooth_brush": "平滑画笔",
	"menu.texture.edit_in_blockbench": "在 Blockbench 中编辑",
	"menu.mirror_painting.axis": "轴",
	"menu.mirror_painting.axis.desc": "选择将在哪个轴上镜像描边",
	"menu.mirror_painting.global": "全局对称",
	"menu.mirror_painting.global.desc": "在全局空间中的模型上启用镜像绘制",
	"menu.mirror_painting.local": "局部对称",
	"menu.mirror_painting.local.desc": "在本地空间中为每个元素启用镜像绘制",
	"menu.mirror_painting.texture_frames": "动画纹理帧",
	"menu.mirror_painting.texture_frames.desc": "将笔画镜像到动画纹理的每一帧",
	"format.bedrock_block.info.size_limit": "块的总大小在所有维度上限制为 30 像素。 上线最多可以在所有方向上偏离块中心 7 个像素。",
	"format.bedrock_block.info.textures": "在 Blockbench 中，可以将多种纹理应用于不同的立方体，但需要在行为包中进行额外的设置才能在游戏中正常工作。",
	"format.image.desc": "在 2D 图像编辑器中编辑图像",
	"generic.delete_all": "删除所有",
	"message.child_model_only.open": "打开父级",
	"dialog.project.credit": "制作信息",
	"dialog.convert_project.create_copy": "创建副本",
	"dialog.texture.frame_time": "帧时间",
	"dialog.texture.frame_time.desc": "设置每帧可见的时长，以刻度为单位。 每个刻度为 1/20 秒。",
	"dialog.texture.frame_interpolate": "插入",
	"dialog.texture.frame_interpolate.desc": "在下一个动画帧之前插入淡入淡出",
	"dialog.texture.frame_order_type": "循环模式",
	"dialog.texture.frame_order_type.loop": "循环",
	"dialog.texture.frame_order_type.backwards": "反向循环",
	"dialog.texture.frame_order_type.back_and_forth": "往返循环",
	"dialog.texture.frame_order_type.custom": "自定义顺序",
	"dialog.texture.frame_order": "帧顺序",
	"dialog.texture.frame_order.desc": "通过按新顺序列出帧索引来设置自定义帧顺序。 第一帧的帧索引从 0 开始。",
	"dialog.select.mode": "模式",
	"dialog.select.mode.new": "新选择",
	"dialog.select.mode.add": "添加到已选择",
	"dialog.select.mode.remove": "从已选择移除",
	"dialog.select.mode.in_selection": "仅从已选择内容中选择",
	"dialog.predicate_overrides.model": "模型",
	"dialog.predicate_overrides.predicates": "谓词",
	"dialog.predicate_overrides.variants": "变体",
	"dialog.predicate_overrides.start_value": "开始",
	"dialog.predicate_overrides.add_override": "添加覆写",
	"dialog.predicate_overrides.add_predicate": "添加谓词",
	"dialog.predicate_overrides.generate_overrides": "生成覆写",
	"dialog.predicate_overrides.confirm_delete": "您确定要删除所有覆写吗？",
	"dialog.predicate_overrides.predicate.angle": "指南针角度",
	"dialog.predicate_overrides.predicate.blocking": "已遮挡",
	"dialog.predicate_overrides.predicate.broken": "已损坏",
	"dialog.predicate_overrides.predicate.cast": "已施出",
	"dialog.predicate_overrides.predicate.cooldown": "冷却中",
	"dialog.predicate_overrides.predicate.damage": "损坏",
	"dialog.predicate_overrides.predicate.damaged": "已损坏",
	"dialog.predicate_overrides.predicate.lefthanded": "左手",
	"dialog.predicate_overrides.predicate.pull": "拉伸值",
	"dialog.predicate_overrides.predicate.pulling": "正在拉伸",
	"dialog.predicate_overrides.predicate.charged": "已拉开",
	"dialog.predicate_overrides.predicate.firework": "有火箭",
	"dialog.predicate_overrides.predicate.throwing": "准备好投掷",
	"dialog.predicate_overrides.predicate.time": "当日时间",
	"dialog.predicate_overrides.predicate.custom_model_data": "自定义模型信息",
	"dialog.predicate_overrides.predicate.level": "光照强度",
	"dialog.predicate_overrides.predicate.filled": "收纳袋装满程度",
	"dialog.predicate_overrides.predicate.tooting": "嘟嘟",
	"settings.model_export_scale": "模型导出比例",
	"settings.model_export_scale.desc": "导出 glTF、DAE 和 FBX 模型的缩放比例。默认为 16，即在导出时将 16 个 Blockbench 单位转换为 1 米。",
	"action.export_fbx": "导出 FBX 模型",
	"action.export_fbx.desc": "将模型和动画导出为 FBX 文件以在其他 3D 应用程序和游戏引擎中使用",
	"action.center_lateral": "中央横向",
	"action.center_lateral.desc": "在 X 和 Z 轴上将所选元素居中",
	"action.adjust_opacity": "调整不透明度...",
	"action.adjust_opacity.desc": "调整所选纹理的不透明度",
	"action.rotate_texture_cw": "顺时针旋转",
	"action.rotate_texture_ccw": "逆时针旋转",
	"action.predicate_overrides": "编辑谓词覆写...",
	"action.predicate_overrides.desc": "根据所选条件选择模型以覆盖原模型",
	"action.auto_set_cullfaces": "设置自动剔除面",
	"action.auto_set_cullfaces.desc": "当面被相邻块覆盖时，自动剔除面以隐藏面。",
	"menu.texture.edit_externally": "外部编辑",
	"menu.mirror_painting.texture": "2D 编辑器对称性",
	"menu.mirror_painting.texture.desc": "在图像或纹理的 2D 空间中启用镜像绘制",
	"menu.animator.rotation_global": "在全局空间中旋转",
	"uv_editor.face_properties": "面属性",
	"uv_editor.face_properties.material_instance": "材质实例",
	"uv_editor.tint.info": "启用着色可以让 Minecraft 进行相应面的着色处理。原版仅能对特定方块或物品进行着色，例如树叶块、红石粉，且值仅能为 0。",
	"uv_editor.cullface.info": "启用剔除面可以让此方块的面在特定方向存在相邻方块时不进行渲染。这可以用来优化游戏性能。",
	"uv_editor.material_instance.info": "材质实例可以设置自定义名称。该名称可以在行为包中的 JSON 文件中使用，以便为特点的面指定特定的纹理和材质。",
	"display.reference.frame_invisible": "物品展示框（隐形）",
	"data.settings_profile": "配置",
	"message.display_skin.invalid_name": "找不到名为 “%0” 的 Minecraft 账号。",
	"dialog.load_plugins_from_query.title": "加载插件",
	"dialog.load_plugins_from_query.text": "此链接的插件需要被安装。您确定要安装此插件吗？",
	"dialog.select_model.title": "选择模型",
	"dialog.select_model.bones": "骨骼",
	"dialog.select_model.cubes": "立方体",
	"dialog.settings.create_profile": "创建配置...",
	"settings_profile.confirm_delete": "确定删除此配置？",
	"settings_profile.condition.type.selectable": "手动可选",
	"settings.interface_mode": "UI 模式",
	"settings.interface_mode.desc": "用户界面模式",
	"settings.interface_mode.auto": "自动",
	"settings.interface_mode.desktop": "桌面",
	"settings.interface_mode.mobile": "移动设备",
	"settings.paint_through_transparency": "穿过透明部分绘画",
	"settings.paint_through_transparency.desc": "当 Alpha 通道锁定时，笔刷将穿透透明的区域",
	"action.tab_overview": "标签页总览",
	"action.tab_overview.desc": "查看所有打开的标签页并跳转至其中一个",
	"action.slider_color_red": "红色",
	"action.slider_color_green": "绿色",
	"action.slider_color_blue": "蓝色",
	"action.add_animation_controller": "加入动作控制器",
	"action.add_animation_controller.desc": "创建动作控制器",
	"action.animation_controller_preview_mode": "预览",
	"action.animation_controller_preview_mode.paused": "已暂停",
	"action.animation_controller_preview_mode.manual": "手动预览",
	"action.animation_controller_preview_mode.play": "自动播放",
	"action.keyframe_interpolation.bezier": "贝塞尔",
	"action.keyframe_bezier_linked": "连接贝塞尔手柄",
	"action.keyframe_bezier_linked.desc": "连接左和右关键帧的贝塞尔手柄",
	"action.reset_keyframe_handles": "重置关键帧手柄",
	"action.reset_keyframe_handles.desc": "重置已选中关键帧的贝塞尔手柄",
	"action.looped_animation_playback": "循环播放",
	"action.looped_animation_playback.desc": "无限循环预览动画",
	"timeline.bind_to_actor": "绑定于演员",
	"animation_controllers.select_preset": "选择控制器预设...",
	"animation_controllers.state.animations": "动画",
	"animation_controllers.state.particles": "粒子",
	"animation_controllers.state.sounds": "音效",
	"animation_controllers.state.on_entry": "进入时",
	"animation_controllers.state.on_exit": "退出时",
	"animation_controllers.state.transitions": "过渡动画",
	"animation_controllers.state.condition": "条件",
	"animation_controllers.state.blend_transition": "混合时间",
	"animation_controllers.state.shortest_path": "按最短的路径混合",
	"animation_controllers.state.edit_transition": "编辑过渡动画",
	"menu.color_picker.picker_type": "拾色器类型",
	"menu.color_picker.picker_type.square": "正方形",
	"menu.color_picker.picker_type.wheel": "圆轮",
	"menu.color_picker.slider_mode": "滑块模式",
	"menu.color_picker.slider_mode.hsv": "色相、饱和度、明度",
	"menu.color_picker.slider_mode.rgb": "RGB",
	"menu.texture.render_mode.additive": "添加",
	"panel.color.picker_options": "取色器设置",
	"panel.animation_controllers": "动画控制器",
	"display.preset.armor_stand": "地面（盔甲架）",
	"data.file_path": "文件路径",
	"dialog.extrude.orientation": "坐标系",
	"dialog.extrude.orientation.upright": "直立",
	"dialog.extrude.orientation.flat": "平坦",
	"dialog.scale.box_uv_warning": "缩放箱型 UV 可能会破坏模型 UV。相反，请尝试在外部缩放你的模型，或者在“文件” > “项目”中切换到逐面 UV 模式。",
	"dialog.create_gif.format": "格式",
	"dialog.create_gif.format.gif": "GIF",
	"dialog.create_gif.format.png_sequence": "PNG 序列",
	"dialog.create_gif.pixelate": "像素化",
	"dialog.create_gif.bg_image": "背景图片",
	"dialog.create_gif.turn.desc": "在录制中旋转模型。使用负数值顺时针旋转。60 相当于每秒旋转一周。",
	"settings_profile.condition": "条件",
	"settings_profile.condition.type.file_path.desc": "使用正则表达式语法以对应当前项目的文件路径。使用正斜杠标注目录",
	"settings.only_selected_bezier_handles": "仅显示所选贝塞尔手柄",
	"settings.only_selected_bezier_handles.desc": "隐藏未选中的贝塞尔手柄",
	"settings.embed_textures": "嵌入纹理",
	"settings.embed_textures.desc": "嵌入纹理到 .bbmodel 工程文件",
	"action.selection_mode.cluster": "组",
	"dialog.copied_to_clipboard": "复制到剪贴板",
	"data.reference_image": "参考图像",
	"message.delete_reference_image": "您确定要删除该参考图吗？此操作无法撤销。",
	"message.add_reference_image.message": "选择参考图要加载的位置",
	"message.import_particle_texture.import": "导入粒子材质",
	"message.import_particle_texture.message": "你要为粒子导入纹理文件吗?",
	"message.save_codec_selector.title": "保存模型格式",
	"message.save_codec_selector.message": "选择保存模型的格式。",
	"message.save_codec_selector.project_file": "Blockbench 项目（.bbmodel）",
	"message.save_codec_selector.both": "都",
	"message.display_skin.username": "用户名（JAVA）",
	"message.palette_locked": "调色板已锁定",
	"dialog.project.default_uv_mode": "默认 UV 模式",
	"dialog.project.default_uv_mode.description": "此项目的默认 UV 模式。每个块都可以更改 UV 模式。",
	"dialog.export_options.title": "导出选项",
	"dialog.edit_texture.preview": "预览",
	"dialog.proportional_editing.range": "范围",
	"dialog.proportional_editing.falloff": "衰减方式",
	"dialog.proportional_editing.falloff.linear": "线性",
	"dialog.proportional_editing.falloff.hermite_spline": "平滑",
	"dialog.proportional_editing.falloff.constant": "固定",
	"dialog.proportional_editing.selection": "选择",
	"dialog.proportional_editing.selection.linear": "线性距离",
	"dialog.proportional_editing.selection.connections": "衔接",
	"dialog.mirror_painting_texture_center.middle": "中间",
	"dialog.mirror_painting_texture_center.custom": "自定义",
	"dialog.settings.reset_to_default": "重置至原值",
	"keybindings.item.num_slider.increase": "增加",
	"keybindings.item.num_slider.decrease": "减少",
	"settings.always_show_splash_art": "始终显示开屏画面",
	"settings.always_show_splash_art.desc": "始终显示开始界面的开屏画面",
	"action.slider_palette_color": "切换调色板颜色",
	"action.slider_palette_color.desc": "循环切换调色板中颜色",
	"action.proportional_editing": "衰减编辑",
	"action.proportional_editing.desc": "在调整模型部分时同时按比例影响周边顶点",
	"action.limit_to_palette": "限制为调色板内颜色",
	"action.limit_to_palette.desc": "限制材质中的颜色为现有调色板中颜色",
	"action.edit_reference_images": "编辑参考图像",
	"action.edit_reference_images.desc": "打开参考图像模式以添加或编辑参考图和蓝图",
	"action.add_reference_image": "添加参考图像",
	"action.reference_image_from_clipboard": "从剪贴板读取参考图像",
	"action.reference_image_list": "参考图像",
	"action.connect_uv_faces": "连接 UV 面",
	"action.connect_uv_faces.desc": "将选中的 UV 面连接于上次选中的 UV 面",
	"action.merge_uv_vertices": "合并 UV 顶点",
	"action.merge_uv_vertices.desc": "将首先选中的 UV 顶点对其于最后选中的 UV 顶点",
	"action.bedrock_animation_mode": "Bedrock 版动画模式",
	"action.bedrock_animation_mode.desc": "选中为 Minecraft: Bedrock 版编辑动画的模式",
	"action.bedrock_animation_mode.entity": "实体",
	"action.bedrock_animation_mode.attachable_first": "物品第一人称",
	"action.bedrock_animation_mode.attachable_third": "物品第三人称",
	"timeline.amplify": "放大",
	"menu.options": "选项...",
	"menu.palette.lock_palette": "锁定调色板",
	"menu.uv.export": "导出 UV 贴图",
	"menu.uv.flip_x": "反转 X 轴",
	"menu.uv.flip_y": "反转 Y 轴",
	"menu.mirror_painting.enabled": "启用",
	"reference_image.position": "位置",
	"reference_image.size": "尺寸",
	"reference_image.rotation": "旋转",
	"reference_image.opacity": "透明度",
	"reference_image.visibility": "可见",
	"reference_image.clear_mode": "明晰模式",
	"reference_image.layer": "层级",
	"reference_image.layer.background": "置于模型下方",
	"reference_image.layer.viewport": "置于模型上方",
	"reference_image.layer.float": "置于界面上方",
	"reference_image.scope": "范围",
	"reference_image.scope.project": "此项目",
	"reference_image.scope.global": "全部项目",
	"reference_image.enabled_modes": "在模型中启用",
	"codec.common.encoding": "编码",
	"codec.common.armature": "将分组作为骨架导出",
	"codec.common.export_animations": "导出动作",
	"codec.common.embed_textures": "内嵌纹理",
	"preview.center_camera": "相机居中",
	"display.reference.frame_top": "表面展示框",
	"display.reference.frame_top_invisible": "表面展示框（隐形）",
	"action.proportional_editing_range": "等比例编辑范围",
	"action.proportional_editing_range.desc": "调整等比例编辑的范围",
	"action.toggle_all_reference_images": "隐藏/展示全部参考图",
	"action.toggle_all_reference_images.desc": "同时隐藏/展示全部参考图",
	"action.add_animation_controller_state": "增加动画控制状态",
	"action.add_animation_controller_state.desc": "为动画控制增加新状态",
	"menu.slider.round_value": "舍入值",
	"texture.error.too_large": "分辨率超越了最大尺寸 %0",
	"dialog.copy_to_clipboard": "复制到剪切板中",
	"dialog.open_url": "打开 URL 链接",
	"reference_image.image": "图像",
	"uv_editor.rotate_uv": "旋转 UV",
	"generic.error": "错误",
	"projects.start_screen": "启动画面",
	"message.invalid_link.message": "你企图加载的分享模型“%0”可能无效或已过期。",
	"message.plugin_dependencies.title": "插件依赖",
	"message.plugin_dependencies.message1": "插件需要前置：",
	"message.plugin_dependencies.message1_update": "插件已被更新并需要前置：",
	"message.plugin_dependencies.message2": "你是否要安装它们并继续？",
	"message.plugin_dependencies.invalid": "插件无法被安装，无效前置：",
	"message.preview_scene_load_failed": "无法加载预览场景。检查互联网连接。",
	"dialog.convert_project.text1": "将项目转化为另一格式。",
	"dialog.convert_project.text2": "请谨慎转化。不同格式有着不同功能及限制，某些转化将破坏部分项目。",
	"dialog.convert_project.text3": "你无法撤销转化，因此默认情况下将会复制一份副本。",
	"dialog.unsaved_work.title": "未保存的变更",
	"dialog.unsaved_work.text": "以下项目有未保存的变更。是否保存更改？",
	"dialog.unsaved_work.discard_all": "全都丢弃",
	"dialog.unsaved_work.save_all": "全都保存",
	"dialog.resize_texture.mode": "模式",
	"dialog.resize_texture.mode.crop": "裁切/扩展",
	"dialog.resize_texture.mode.scale": "缩放",
	"dialog.plugins.is_installed": "已安装",
	"dialog.plugins.is_disabled": "已禁用",
	"dialog.plugins.disable": "禁用",
	"dialog.plugins.enable": "启用",
	"dialog.plugins.dependencies": "依赖于：",
	"dialog.view_backups.open_folder": "打开文件夹",
	"dialog.share_model.reference_images": "包括参考图像",
	"dialog.share_model.too_large": "上传失败：模型过大",
	"dialog.share_model.too_large_references": "上传失败：模型过大。请取消参考图像并再次尝试。",
	"settings.stretch_linked": "连锁拉伸",
	"settings.stretch_linked.desc": "将立方体向各方向拉伸相同值",
	"settings.grids": "显示网格",
	"settings.grids.desc": "显示还是隐藏全部 3D 网格",
	"settings.double_click_switch_tools": "双击时切换工具",
	"settings.double_click_switch_tools.desc": "双击视口以切换工具",
	"settings.outlines_in_paint_mode": "在绘制模式下选择轮廓",
	"settings.outlines_in_paint_mode.desc": "在绘制模式下显示所选元素的轮廓",
	"settings.json_indentation": "JSON 首行缩进",
	"settings.json_indentation.desc": "导出的 JSON 文件使用首行缩进格式",
	"settings.json_indentation.tabs": "Tabs",
	"settings.json_indentation.spaces_4": "空格：4",
	"settings.json_indentation.spaces_2": "空格：2",
	"action.slider_stretch": "拉伸",
	"action.slider_stretch.desc": "将立方体沿轴成倍拉伸而不改变其 UV",
	"action.view_backups": "查看备份",
	"action.view_backups.desc": "浏览自动保存的项目备份列表",
	"action.search_outliner": "搜索大纲",
	"action.search_outliner.desc": "在大纲中以关键词检索元素名称",
	"action.mirror_modeling": "镜像编辑模式",
	"action.mirror_modeling.desc": "在 X 轴上启用镜像编辑模式。你在视口中做的一切更改都会折射到另一边，除非元素有上特殊禁用。",
	"action.allow_element_mirror_modeling": "启用镜像编辑模式",
	"action.allow_element_mirror_modeling.desc": "选择所选元素是否受镜像编辑模式影响",
	"action.switch_face_crease": "切换面折叠",
	"action.switch_face_crease.desc": "切换面的对折方向",
	"action.clear_unused_texture_space": "清除纹理未使用的部分",
	"action.clear_unused_texture_space.desc": "将纹理中没有对应元素 UV 映射的部分清除",
	"action.split_screen": "分屏",
	"action.split_screen.desc": "选择视口分屏模式",
	"action.split_screen.single": "单屏",
	"action.split_screen.double_horizontal": "水平双屏",
	"action.split_screen.double_vertical": "垂直双屏",
	"action.split_screen.quad": "四屏",
	"action.split_screen.triple_left": "三连左屏",
	"action.split_screen.triple_right": "三连右屏",
	"action.split_screen.triple_top": "三连上屏",
	"action.split_screen.triple_bottom": "三连下屏",
	"action.uv_project_from_view": "自视角投射 UV",
	"action.uv_project_from_view.desc": "以 3D 视图的视角为所选的面自动生成 UV",
	"action.graph_editor_other_graphs": "显示其他图表",
	"action.graph_editor_other_graphs.desc": "决定未选中的轴的图表是否被展示",
	"action.graph_editor_include_other_graphs": "包含其他轴",
	"action.graph_editor_include_other_graphs.desc": "决定图标编辑器是否包括视图中未选中的图表",
	"action.set_ik_source": "设定 IK 根",
	"action.set_ik_source.desc": "设定这个空对象能够以反向运动学移动的链的根",
	"edit.loop_cut.cuts": "切",
	"panel.element.stretch": "拉伸",
	"preview_scene.minecraft_plains": "平原",
	"preview_scene.minecraft_cherry_grove": "樱花树林",
	"preview_scene.minecraft_snowy_tundra": "雪原",
	"preview_scene.minecraft_sunset": "日落",
	"preview_scene.minecraft_night": "夜晚",
	"preview_scene.minecraft_desert": "沙漠",
	"preview_scene.minecraft_underwater": "水下",
	"preview_scene.minecraft_coral_reef": "珊瑚礁",
	"preview_scene.minecraft_lush_cave": "繁茂洞穴",
	"preview_scene.minecraft_deep_dark": "深暗之域",
	"generic.navigate_forward": "前",
	"generic.navigate_back": "后",
	"action.element_render_order": "透明度渲染顺序",
	"action.element_render_order.default": "自动",
	"action.element_render_order.behind": "后面",
	"action.element_render_order.in_front": "前面",
	"message.installing_update.title": "无可用更新",
	"message.installing_update.message": "有新版本可供更新。在关闭软件后，请等待约 %0 秒再重新启动 Blockbench 或关闭电脑，以安装新版本。",
	"settings.brush_cursor_2d": "2D 笔刷光标",
	"settings.brush_cursor_2d.desc": "在 2D 工作台中显示笔刷轮廓",
	"settings.brush_cursor_3d": "3D 笔刷光标",
	"settings.brush_cursor_3d.desc": "在 3D 工作台中显示笔刷轮廓",
	"settings.cdn_mirror": "使用 CDN 镜像",
	"settings.cdn_mirror.desc": "使用镜像 CDN 下载插件。镜像接收更新的速度更快，并且可以在默认设置失效的某些地区中使用。",
	"data.layer": "图层",
	"data.panel": "面板",
	"generic.confirm_delete": "确定删除吗？",
	"format_category.general": "总体",
	"modifier_actions.no_uniform_scaling": "自由缩放",
	"message.texture_refresh_conflict.title": "纹理版本冲突",
	"message.texture_refresh_conflict.message": "纹理文件可能存在与 Blockbench 版本冲突的内容",
	"message.texture_refresh_conflict.keep_ours": "保持 Blockbench 的版本",
	"message.texture_refresh_conflict.keep_theirs": "加载文件并放弃 Blockbench 内的更改与图层",
	"message.group_required_to_animate": "你无法对此类元素应用动画。创建一个分组以对其应用动画。",
	"dialog.texture.uv_size": "UV 尺寸",
	"dialog.advanced_screenshot.angle_preset": "预设角度",
	"dialog.advanced_screenshot.resolution": "分辨率",
	"dialog.advanced_screenshot.zoom_to_fit": "缩放以适配",
	"dialog.advanced_screenshot.zoom": "缩放/焦距",
	"dialog.advanced_screenshot.anti_aliasing": "抗锯齿",
	"dialog.advanced_screenshot.anti_aliasing.off": "关闭",
	"dialog.advanced_screenshot.anti_aliasing.msaa": "多取样",
	"dialog.advanced_screenshot.anti_aliasing.ssaa": "超取样",
	"dialog.advanced_screenshot.show_gizmos": "显示操作手柄",
	"dialog.advanced_screenshot.shading": "阴影",
	"settings.auto_keyframe": "自动关键帧",
	"settings.auto_keyframe.desc": "当更改骨骼时，在时间线起始自动添加默认状态关键帧",
	"settings.modded_entity_integer_size": "模组实体整数尺寸",
	"settings.modded_entity_integer_size.desc": "将模组实体的立方体大小限制为整数。尽管某些版本技术上支持浮点数，整数尺寸更适于 UV 映射。",
	"category.layers": "图层",
	"keybind.paint_secondary_color": "用次要颜色绘制",
	"action.selection_tool_operation_mode": "选择模式",
	"action.selection_tool_operation_mode.create": "新的选择",
	"action.selection_tool_operation_mode.add": "加展选中",
	"action.selection_tool_operation_mode.subtract": "减展选中",
	"action.selection_tool_operation_mode.intersect": "相交",
	"action.pixel_perfect_drawing": "完美像素绘制模式",
	"action.pixel_perfect_drawing.desc": "不在转弯处产生双像素而精准绘制出像素",
	"action.selection_tool": "选区工具",
	"action.selection_tool.desc": "选取部分图像",
	"action.selection_tool.rectangle": "长方形",
	"action.selection_tool.ellipse": "椭圆",
	"action.selection_tool.lasso": "套索选择",
	"action.selection_tool.wand": "魔棒工具",
	"action.selection_tool.color": "同种颜色",
	"action.move_layer_tool": "移动图层",
	"action.move_layer_tool.desc": "移动当前图层或选区",
	"action.export_modded_animations": "导出模组实体动画",
	"action.export_modded_animations.desc": "为 Java 版模组实体模型导出动画",
	"action.swap_colors": "切换颜色",
	"action.swap_colors.desc": "在主要和次要颜色之间切换",
	"action.apply_mesh_rotation": "应用旋转",
	"action.apply_mesh_rotation.desc": "重置网格的元素旋转，并将其应用于几何",
	"action.flip_texture_x.desc": "水平翻转纹理或图层",
	"action.flip_texture_y.desc": "垂直翻转纹理或图层",
	"action.rotate_texture_cw.desc": "将纹理或图层顺时针旋转",
	"action.rotate_texture_ccw.desc": "将纹理或图层逆时针旋转",
	"action.crop_texture_to_selection": "将纹理裁剪至选区内",
	"action.create_empty_layer": "创造空白图层",
	"action.enable_texture_layers": "启用图层",
	"action.disable_texture_layers": "禁用图层",
	"action.layer_opacity": "图层透明度",
	"action.layer_to_texture_size": "放大图层至纹理尺寸",
	"action.layer_to_texture_size.desc": "放大纹理至图层尺寸",
	"action.merge_layer_down": "向下合并",
	"action.merge_layer_down.desc": "向下合并入图层",
	"action.advanced_screenshot": "高级截屏...",
	"action.advanced_screenshot.desc": "使用高级选项对模型截屏",
	"action.bake_ik_animation": "烘焙反向运动",
	"action.bake_ik_animation.desc": "将反向运动提供的旋转烘培入所选的动画内",
	"action.save_animation_preset": "保存动画预设...",
	"action.save_animation_preset.desc": "将所选的关键帧保存为动画预设",
	"action.animation_onion_skin": "动画洋葱皮",
	"action.animation_onion_skin.desc": "展示动画其他帧的线框作为参考",
	"action.apply_animation_preset": "应用动画映射",
	"action.apply_animation_preset.desc": "选择动画映射并应用于所选骨骼",
	"menu.brush_presets.pixel_perfect": "完美像素笔刷",
	"panel.layers": "图层",
	"uv_editor.copy_paste_tool.to_layer": "至新图层",
	"format.image.new": "创建新图层",
	"format.image.info.summary": "2D 图像编辑器让你在 Blockbench 中无需外接图像编辑器，而直接创建并编辑图像于像素艺术。编辑图像，更改纹理，或创建自己的像素作品吧！",
	"settings.move_with_selection_tool": "使用选区工具移动选区",
	"settings.move_with_selection_tool.desc": "使选区工具能够直接移动选区，而不用切换到移动图层工具",
	"settings.final_newline": "结束换行符",
	"settings.final_newline.desc": "在导出文件的末尾增加一个换行符",
	"action.crop_layer_to_selection": "将图层裁切至选区内",
	"action.edit_mode_uv_overlay.desc": "在编辑模式下显示所有元素的 UV 贴图叠加层",
	"menu.image": "图像",
	"menu.texture.discard_changes": "撤销更改",
	"menu.texture.discard_changes.desc": "撤销全部未保存更改并从文件中加载最新版本",
	"panel.textures.images": "图像",
	"dialog.advanced": "高级",
	"dialog.recommended_option": "推荐用",
	"modifier_actions.snap_to_center": "对其至中线",
	"modifier_actions.snap_to_pixels": "对其至像素",
	"message.invalid_format.install_plugin": "安装插件“%0”",
	"message.plugin_deprecated.message": "你确定要安装已弃用插件？",
	"message.plugin_deprecated.install_anyway": "无论安装",
	"message.image_editor.not_found": "无法找到所选的图像编辑器。请选择其他选项。",
	"message.knife_tool.confirm": "按 %0 或点击此处以应用刀具工具",
	"message.knife_tool.skipped_face": "无法在不同面之间进行切割。包括之间的边或顶点！",
	"message.optimize_animation.keyframes_removed": "移除了 %0 张重复关键帧",
	"message.optimize_animation.nothing_to_optimize": "没有可优化部分！",
	"message.duplicate_bone_copy_animation.title": "复制动画",
	"message.duplicate_bone_copy_animation.message": "复制的骨骼在 %0 动画中有动画。要将关键帧复制到新骨骼上吗？",
	"message.auto_fix_mesh_edit.title": "自动修正",
	"message.auto_fix_mesh_edit.revert": "撤销编辑",
	"message.auto_fix_mesh_edit.overlapping_vertices": "某些顶点被移动至同一位置。你想要如何继续？",
	"message.auto_fix_mesh_edit.concave_quads": "一个或多个面现已内陷，在 UV 映射与渲染中可能导致问题。Blockbench 可以自动为你修正：",
	"message.auto_fix_mesh_edit.merge_vertices": "合并顶点",
	"message.auto_fix_mesh_edit.split_quads": "分隔相同",
	"message.load_images.add_image": "增添图像",
	"dialog.project.modded_entity_entity_class": "实体层级",
	"dialog.resize_texture.offset": "偏移",
	"dialog.animated_texture_editor.code_reference": "代码参考",
	"dialog.animated_texture_editor.code_reference.about": "此代码被生成来用于实现纹理动画，仅供参考，不修改不一定能正常工作。请查看文档以了解更多信息。",
	"dialog.animated_texture_editor.code_reference.docs": "文档",
	"dialog.animated_texture_editor.reframe": "重帧",
	"dialog.animated_texture_editor.stride": "帧尺寸",
	"dialog.animated_texture_editor.frames": "帧数量",
	"dialog.animated_texture_editor.add_frame": "增加帧",
	"dialog.animated_texture_editor.resize_frames": "重设帧尺寸...",
	"dialog.animated_texture_editor.apply": "应用",
	"dialog.add_primitive.edge_size": "边缘大小",
	"dialog.change_animation_speed.speed": "速度",
	"dialog.change_animation_speed.adjust_snapping": "调整吸附",
	"dialog.optimize_animation.selection": "选择",
	"dialog.optimize_animation.selection.selected_keyframes": "所选关键帧",
	"dialog.optimize_animation.selection.selected_animation": "所选动画",
	"dialog.optimize_animation.selection.all_animations": "全部动画",
	"dialog.optimize_animation.thresholds": "阈值大小",
	"dialog.import_obj.obj": "OBJ 文件",
	"dialog.import_obj.mtl": "MTL 文件",
	"dialog.import_obj.scale": "缩放",
	"layout.thumbnail": "自定义小图 CSS",
	"settings.pixel_grid": "像素网格",
	"settings.pixel_grid.desc": "在编辑模式下展示像素网格",
	"settings.image_editor_grid_size": "图像编辑器网格尺寸",
	"settings.image_editor_grid_size.desc": "在 2D 图像编辑器中的大网格的尺寸",
	"settings.ground_plane_double_side": "双面地平面",
	"settings.ground_plane_double_side.desc": "使地平面从下方可见",
	"settings.optifine_save_default_texture": "OptiFine JEM：导出所选纹理",
	"settings.optifine_save_default_texture.desc": "将所选纹理作为模型默认纹理导出",
	"action.slider_color_select_threshold": "色彩选择阈值",
	"action.slider_color_select_threshold.desc": "相邻像素的颜色要多相似以被颜色工具或魔棒工具选中",
	"action.stretch_tool": "拉伸",
	"action.stretch_tool.desc": "用于拉伸元素的工具",
	"action.knife_tool": "刀具工具",
	"action.knife_tool.desc": "用于将网格面切割为更小形状的工具",
	"action.duplicate_project": "复制项目",
	"action.duplicate_project.desc": "创建当前项目的副本",
	"action.transform_space.parent": "父级",
	"action.transform_pivot_space": "驱轴变换空间",
	"action.solidify_mesh_selection": "固化面",
	"action.solidify_mesh_selection.desc": "使网格上所选的面固化",
	"action.animated_texture_editor": "手翻书动画...",
	"action.animated_texture_editor.desc": "设定或编辑所选纹理的手翻书动画",
	"action.center_individual_pivots": "居中独立驱轴",
	"action.center_individual_pivots.desc": "将所选元素的驱轴分别居中",
	"action.uv_cycle": "循环 UV",
	"action.uv_cycle.desc": "顺序循环 UV 顶点而不改变 UV 位置",
	"action.uv_cycle_invert": "循环翻转 UV",
	"action.uv_cycle_invert.desc": "反向循环 UV 顶点而不改变 UV 位置",
	"action.slider_animation_controller_speed": "控制回放速度",
	"action.slider_animation_controller_speed.desc": "动画控制器的播放速度百分比",
	"action.optimize_animation": "优化动画",
	"action.optimize_animation.desc": "优化当前动画并减少关键帧数量",
	"action.change_animation_speed": "更改动画速度...",
	"action.change_animation_speed.desc": "改变所选动画的速度",
	"timeline.select_particle_file": "选择粒子文件",
	"timeline.select_sound_file": "选择声音文件",
	"menu.cube.texture.default": "默认",
	"menu.texture.particle.clear": "停止粒子应用",
	"menu.texture.use_as_default": "设为默认",
	"menu.texture.use_as_default.clear": "取消默认设定",
	"menu.toolbar.overflow": "工具栏溢出",
	"edit.solidify_mesh_selection.thickness": "粗细度",
	"reference_image.sync_to_timeline": "对齐于时间轴",
	"reference_image.toggle_playback": "播放/停止",
	"dialog.add_primitive.shape.beveled_cuboid": "斜角方形",
	"dialog.ignore_all": "忽略所有",
	"data.texture_group": "纹理组",
	"data.animation": "动画",
	"generic.on": "开启",
	"generic.off": "关闭",
	"format.free.info.3d_printing": "3D 打印",
	"message.invalid_file.merge_conflict": "该文件包含未解决的 Git 合并冲突。",
	"dialog.expand_texture_selection.radius": "数量",
	"dialog.expand_texture_selection.corner": "边角形状",
	"dialog.expand_texture_selection.corner.round": "圆形",
	"dialog.expand_texture_selection.corner.square": "方形",
	"dialog.expand_texture_selection.corner.manhattan": "曼哈顿",
	"dialog.merge_animation.merge_target": "合并到",
	"keybindings.variation_conflict": "按键绑定冲突",
	"settings.recovery_save_interval": "恢复点保存间隔",
	"settings.recovery_save_interval.desc": "Blockbench 会定期在后台保存打开的项目，以便在计算机崩溃时进行恢复。设置以秒为单位的间隔。设置为 0 可禁用保存。",
	"settings.save_view_per_tab": "保存每个标签页的视图",
	"settings.save_view_per_tab.desc": "分别保存每个标签页的当前视角",
	"settings.inherit_parent_color": "继承父级颜色",
	"settings.inherit_parent_color.desc": "将新创建元素的颜色标记设置为父元素的颜色，而不是随机颜色",
	"keybind.preview_select.multi_select": "多项选中",
	"keybind.preview_select.group_select": "分组选中",
	"keybind.preview_select.loop_select": "循环选中",
	"action.fill_mode.selection": "选择",
	"action.fill_mode.selected_elements": "选中的元素",
	"action.image_tiled_view": "平铺视图",
	"action.image_tiled_view.description": "在 2D 编辑器中启用平铺视图",
	"action.image_onion_skin_view": "洋葱皮图像编辑器",
	"action.image_onion_skin_view.description": "在 2D 编辑器中启用洋葱皮视图",
	"action.expand_texture_selection": "扩大纹理选择",
	"action.expand_texture_selection.desc": "扩大或缩小纹理选择",
	"action.switch_tabs.reverse_order": "逆序",
	"action.save_project_incremental": "增量保存项目",
	"action.save_project_incremental.desc": "将当前模型以项目文件的形式增量保存（比如：project_2.bbmodel）",
	"action.copy.multiple": "全部复制",
	"action.copy.multiple.desc": "逐一复制所有可用数据",
	"action.paste.multiple": "全部粘贴",
	"action.randomize_marker_colors": "随机化颜色标记",
	"action.cube_light_emission": "发光",
	"action.cube_light_emission.desc": "更改所选方块的发光强度，值介于 0 到 15 之间",
	"action.view_mode.colored_solid": "有颜色标记的实体",
	"action.focus_on_selection.rotate_only": "只旋转",
	"action.create_texture_group": "创建纹理组",
	"action.create_texture_group.desc": "为你的纹理们创建一个分组",
	"action.uv_maximize.all_faces": "应用到所有面",
	"action.retarget_animators": "重新定位动画",
	"action.retarget_animators.desc": "选择一个动画以及其对应的骨骼或元素",
	"action.merge_animation": "合并动画",
	"action.merge_animation.desc": "将动画合并到另一个动画中",
	"action.add_keyframe.reset_values": "使用默认值",
	"action.set_timeline_range_start": "设置时间线范围开始",
	"action.set_timeline_range_start.desc": "在动画时间轴中设置自定义播放范围的起点",
	"action.set_timeline_range_end": "设置时间线范围结束",
	"action.set_timeline_range_end.desc": "在动画时间轴中设置自定义播放范围的终点",
	"action.disable_timeline_range": "禁用时间线范围",
	"action.disable_timeline_range.desc": "在动画时间轴中禁用自定义播放范围",
	"menu.texture_group.resolve": "解析",
	"menu.image_tiled_view.mirrored": "镜像边缘",
	"menu.image_onion_skin_view.frame": "帧",
	"menu.image_onion_skin_view.frame.last_viewed": "最后查看的帧",
	"menu.image_onion_skin_view.frame.previous": "上一帧",
	"menu.image_onion_skin_view.frame.next": "下一帧",
	"menu.image_onion_skin_view.frame.both": "上一个 + 下一个",
	"menu.image_onion_skin_view.display": "显示",
	"menu.image_onion_skin_view.display.pixels": "更小的像素",
	"menu.image_onion_skin_view.display.transparent": "透明",
	"menu.image_onion_skin_view.above": "上方显示",
	"menu.animation.reload": "重新加载",
	"switches.autouv.alt": "相对",
	"display.rotation_pivot": "旋转枢轴",
	"display.scale_pivot": "缩放枢轴",
	"display.reference.fox": "狐狸",
	"display.reference.eating": "吃东西",
	"preview_scene.sky": "天空",
	"preview_scene.space": "太空",
	"preview_scene.minecraft_ocean": "海洋",
	"message.import_palette.selection_only": "仅选择",
	"dialog.blend_transition_edit.ease_in_out": "渐进渐出（%0）",
	"dialog.blend_transition_edit.generate": "生成...",
	"dialog.blend_transition_edit.generate.learn_more": "预览和更多信息",
	"dialog.blend_transition_edit.generate.curve": "缓动类型",
	"dialog.blend_transition_edit.generate.steps": "关键帧",
	"settings.fps_limit": "FPS 限制",
	"settings.fps_limit.desc": "限制 Blockbench 每秒渲染的帧数。实际帧速率受限于您的设备可以显示的速率。",
	"settings.outliner_reveal_on_select": "选中时显示元素",
	"settings.outliner_reveal_on_select.desc": "在大纲中显示选择轮廓中对应的元素",
	"settings.java_export_pivots": "在 Java 版方块/物品模型中导出枢轴",
	"settings.java_export_pivots.desc": "在没有旋转的立方体上保存枢轴点到 Java 版方块/物品模型中",
	"animation_controllers.state.blend_transition_curve": "混合过渡曲线",
	"menu.slider.reset_vector": "重置向量",
	"dialog.blend_transition_edit.extended": "扩展图表",
	"message.screenshot_too_large.title": "截屏分辨率问题",
	"message.screenshot_too_large.message": "屏幕截图无法成功渲染。请使用较低的分辨率或不进行超采样重试。",
	"message.rename_elements.numbering": "你可以使用特殊字符生成序列号：% 获取元素组内的索引，$ 获取所选内容中的索引。",
	"generic.edit_externally": "外部编辑",
	"message.settings_require_restart.title": "需要重启",
	"message.settings_require_restart.message": "一些设置需要重新启动程序以生效。",
	"message.settings_require_restart.restart_now": "立即重启",
	"message.settings_require_restart.restart_later": "以后重启",
	"message.classroom_mode.install_plugin": "不会教室模式在安装插件",
	"dialog.collection.export_path": "导出路径",
	"dialog.collection.select_all": "选择全部",
	"dialog.collection.select_none": "无选择",
	"dialog.collection.add_with_filter": "使用过滤添加",
	"dialog.collection.remove": "移除",
	"dialog.material_config.title": "材质设置",
	"dialog.material_config.color_value": "颜色值",
	"dialog.material_config.mer": "金属、自发光、粗糙度",
	"dialog.material_config.mer_value": "MER 值",
	"dialog.material_config.depth_type": "深度类型",
	"dialog.create_texture.disable_mirror_uv": "禁用 UV 镜像",
	"dialog.create_texture.disable_mirror_uv.desc": "禁用镜像建模中的 UV 镜像选项，为模型的每一侧保留单独的 UV",
	"dialog.create_gif.turn.sync_to_anim_length": "同步到动画长度",
	"settings.category.controls": "控制",
	"settings.classroom_mode": "教室模式",
	"settings.classroom_mode.desc": "限制安装插件等功能并删除指向社交媒体的链接",
	"settings.antialiasing_bleed_fix": "修复抗锯齿渗出",
	"settings.antialiasing_bleed_fix.desc": "修复使用抗锯齿时的纹理渗出问题",
	"settings.tone_mapping": "色调映射",
	"settings.tone_mapping.desc": "用于在标准屏幕上显示 HDR 以进行 PBR 渲染的近似方法。",
	"settings.audio_scrubbing": "在时间轴上试听音频",
	"settings.audio_scrubbing.desc": "播放音频的简短预览，同时拖动时间轴",
	"settings.viewport_rotate_speed": "视口旋转速度",
	"settings.viewport_rotate_speed.desc": "在视口中旋转时的灵敏度",
	"settings.viewport_zoom_speed": "视口缩放速度",
	"settings.viewport_zoom_speed.desc": "在视口中缩放时的输入灵敏度",
	"settings.editor_2d_zoom_speed": "2D 编辑器缩放速度",
	"settings.editor_2d_zoom_speed.desc": "在 UV 和 2D 绘制编辑器中放大时的灵敏度",
	"category.select": "选择",
	"action.vertex_snap_mode.rotate": "旋转",
	"action.export_image": "导出图像",
	"action.export_image.desc": "将纹理导出为图像文件",
	"action.apply_mirror_modeling": "应用镜像建模",
	"action.apply_mirror_modeling.desc": "将镜像建模应用于所选内容。所有选定的元素都将被复制并沿 X 轴翻转。",
	"action.create_collection": "创建集合",
	"action.create_collection.desc": "从大纲视图选择中创建集合",
	"action.set_collection_content_to_selection": "将集合内容设置为选定对象",
	"action.set_collection_content_to_selection.desc": "将选定的组和元素设置为该集合的内容",
	"action.add_to_collection": "将选定的元素添加到集合中",
	"action.add_to_collection.desc": "将选定的组和元素添加到集合中",
	"action.view_mode.material": "材质预览",
	"action.create_material": "创建材质",
	"action.create_material.desc": "从选定纹理中创建新的 PBR 材质",
	"action.generate_pbr_map": "生成 PBR 贴图",
	"action.generate_pbr_map.desc": "从现有纹理生成 PBR 贴图（高度贴图或金属度、发光度、粗糙度）",
	"menu.tools.main_tools": "工具箱",
	"menu.view.panels": "面板",
	"menu.texture.pbr_channel": "PBR 通道",
	"menu.texture.pbr_channel.color": "颜色",
	"menu.texture.pbr_channel.normal": "法线贴图",
	"menu.texture.pbr_channel.height": "凹凸贴图",
	"menu.texture.pbr_channel.mer": "MER （金属度-自发光-粗糙度）",
	"menu.texture.pbr_channel.mer_subsurface": "MER 次表面",
	"menu.collection.export_project": "导出项目",
	"menu.collection.export_as": "导出为 “%0\"",
	"menu.panel.enable": "启用",
	"menu.panel.move_to": "移到",
	"menu.panel.move_to.left_bar": "左屏侧边栏",
	"menu.panel.move_to.right_bar": "右屏侧边栏",
	"menu.panel.move_to.top": "上屏",
	"menu.panel.move_to.bottom": "下屏",
	"menu.panel.move_to.float": "窗口",
	"menu.panel.move_to.hidden": "隐藏",
	"menu.panel.fold": "折叠",
	"menu.mirror_painting.texture_center": "原点",
	"menu.mirror_modeling.mirror_uv": "镜像 UV",
	"menu.animation_onion_skin.frames": "帧",
	"menu.animation_onion_skin.select": "选择",
	"menu.animation_onion_skin.previous": "上一个",
	"menu.animation_onion_skin.next": "下一个",
	"menu.animation_onion_skin.previous_next": "上一个 + 下一个",
	"menu.animation_onion_skin.count": "数量",
	"menu.animation_onion_skin.interval": "间隔",
	"menu.animation_onion_skin_selective": "选择性洋葱皮",
	"menu.animation_onion_skin_selective.desc": "仅显示模型选定部分的洋葱皮",
	"edit.loop_cut.unit": "单位",
	"edit.loop_cut.unit.size_units": "尺寸单位",
	"edit.loop_cut.unit.percent": "百分之",
	"edit.extrude_mesh_selection.direction": "方向",
	"edit.extrude_mesh_selection.direction.outwards": "向外",
	"edit.extrude_mesh_selection.direction.average": "平均",
	"edit.extrude_mesh_selection.even_extend": "均匀拓展",
	"edit.vertex_snap.align": "对齐",
	"edit.vertex_snap.align.longest": "最长轴",
	"edit.vertex_snap.align.direction": "从枢轴的方向",
	"edit.vertex_snap.align.align_axis": "轴 %0",
	"edit.vertex_snap.ignore_axis": "忽略轴",
	"codec.common.format": "格式",
	"codec.image.quality": "品质",
	"panel.collections": "集合",
	"modifier_actions.always": "始终启用",
	"modifier_actions.unless": "除非 %0",
	"settings.undo_selections": "撤销选择",
	"settings.undo_selections.desc": "将所选内容更改作为撤销历史记录中的一个步骤进行跟踪",
	"action.focus_on_selection.zoom": "缩放以适合视图大小",
	"display.reference.tooting": "吹号角",
	"settings.selection_tolerance": "选择容差",
	"settings.selection_tolerance.desc": "可点击选择的边或顶点的区域大小",
	"action.delete.keep_vertices": "保持边/顶点",
	"menu.mesh": "网格",
	"dialog.material_config.subsurface": "次表面散射",
	"dialog.material_config.subsurface_enabled.desc": "使用 MER 贴图的 Alpha 通道用于次表面散射",
	"settings.pick_combined_color": "选取混合的颜色",
	"settings.pick_combined_color.desc": "在相应像素处拾取所有图层合成后的颜色，而不是活动图层的颜色",
	"action.split_rgb_into_layers": "将 RGB 通道分解成图层",
	"action.split_rgb_into_layers.desc": "将纹理分解为加法色图层，每个 RGB 通道对应一层",
	"dialog.project.java_block_version": "格式版本",
	"data.spline_mesh": "样条",
	"data.billboard": "Billboard",
	"data.armature": "骨架",
	"data.armature_bone": "骨骼",
	"generic.reload": "重新加载",
	"modifier_actions.subtract": "减去",
	"modifier_actions.reduced_intensity": "微调",
	"modifier_actions.select_bone": "选择骨骼",
	"modifier_actions.spline_select_multiple_points": "选择多个点或手柄",
	"modifier_actions.move_panel_without_docking": "不停靠移动",
	"message.save_all_textures.message": "你想保存以下材质吗？",
	"message.save_all_textures.skip": "跳过",
	"dialog.add_spline.shape": "形状",
	"dialog.add_spline.shape.segment": "线段",
	"dialog.add_spline.shape.square": "矩形",
	"dialog.add_spline.shape.circle": "圆形",
	"dialog.add_spline.diameter": "直径",
	"dialog.add_spline.sides_tubular": "管段数",
	"dialog.add_spline.sides_radial": "环段数",
	"dialog.add_spline.radius": "管半径",
	"dialog.add_spline.length": "长度",
	"dialog.add_spline.width": "宽度",
	"dialog.plugins.revoke_permissions": "撤销权限",
	"dialog.expression_editor.pretty_print": "格式化输出",
	"dialog.expression_editor.minify": "压缩",
	"dialog.expression_editor.find_replace": "查找/替换",
	"dialog.create_gif.show_gizmos": "录制操作手柄与网格",
	"dialog.preview_options.title": "预览选项",
	"dialog.preview_options.background": "背景",
	"dialog.preview_options.background.checkerboard": "棋盘格",
	"dialog.preview_options.background.solid": "静态",
	"dialog.preview_options.background.custom_color": "自定义背景颜色",
	"dialog.preview_options.show_gizmos": "显示操作手柄",
	"dialog.skin.texture_source": "纹理来源",
	"dialog.skin.texture_source.template": "生成模板",
	"dialog.skin.texture_source.load_texture": "从 Minecraft 加载",
	"dialog.skin.texture_file": "纹理文件",
	"dialog.convert_skin.adjust_texture": "调整纹理",
	"dialog.settings.clear_profile_value": "清除配置值",
	"layout.section.customize": "自定义",
	"layout.theme.configure": "配置",
	"layout.color.elevated": "悬浮",
	"layout.color.elevated.desc": "悬浮的 UI 元素，通常通过阴影与背景分隔",
	"layout.file.watch_changes": "监视更改并重新加载",
	"settings.autocomplete_code": "代码自动补全",
	"settings.autocomplete_code.desc": "在代码编辑器中显示自动补全建议",
	"settings.detect_flipbook_textures": "检测翻页动画纹理",
	"settings.detect_flipbook_textures.desc": "自动检测翻页动画纹理，并以动画形式预览",
	"settings.double_click_select_reference": "双击选择参考图像",
	"settings.double_click_select_reference.desc": "在视口中双击以选择参考图像",
	"settings.default_keyframe_interpolation": "默认关键帧插值",
	"settings.default_keyframe_interpolation.desc": "选择默认的关键帧插值模式",
	"settings.color_picker_style": "取色器样式",
	"settings.color_picker_style.desc": "选择绘画模式取色器的样式",
	"settings.export_asset_paths": "导出资源路径",
	"settings.export_asset_paths.desc": "选择纹理或动画等资源在 .bbmodel 文件中的保存路径方式",
	"settings.export_asset_paths.relative": "相对路径",
	"settings.export_asset_paths.absolute": "完整路径",
	"settings.export_asset_paths.both": "相对路径与完整路径（仅纹理）",
	"settings.export_asset_paths.none": "不导出",
	"action.slider_spline_resolution": "样条分辨率 %0",
	"action.slider_spline_resolution.desc": "在 %0 轴上更改样条分辨率（%1）",
	"action.slider_spline_resolution.u.desc_precision": "环段数",
	"action.slider_spline_resolution.v.desc_precision": "管段数",
	"action.slider_spline_radius": "样条半径",
	"action.slider_spline_radius.desc": "更改样条半径",
	"action.slider_spline_handle_tilt": "手柄倾斜",
	"action.slider_spline_handle_tilt.desc": "更改样条手柄倾斜",
	"action.slider_spline_handle_size": "手柄大小",
	"action.slider_spline_handle_size.desc": "更改样条手柄大小",
	"action.blend_mode.lighten": "变亮",
	"action.blend_mode.darken": "变暗",
	"action.weight_brush": "权重画笔",
	"action.weight_brush.desc": "在网格上绘制顶点权重以用于骨架形变",
	"action.convert_minecraft_skin_variant": "转换细臂/宽臂皮肤",
	"action.convert_minecraft_skin_variant.desc": "在经典的宽模型（Steve）和细模型（Alex）中切换，你可以选择是否让材质自适应模型",
	"action.custom_skin_poses": "自定义皮肤姿势",
	"action.custom_skin_poses.desc": "加载自定义皮肤姿势预设",
	"action.custom_skin_poses.update": "更新姿势",
	"action.custom_skin_poses.update.desc": "用模型的当前姿势覆盖已保存的姿势",
	"action.add_custom_skin_pose": "添加自定义皮肤姿势",
	"action.add_custom_skin_pose.desc": "将模型的当前姿势保存为姿势预设",
	"action.export_stl": "导出为 STL",
	"action.export_stl.desc": "导出用于 3D 打印的 STL 模型",
	"action.add_element": "添加元素",
	"action.add_element.desc": "从元素类型列表中添加一个新元素",
	"action.add_spline": "添加样条",
	"action.add_spline.desc": "添加一个新的样条",
	"action.add_billboard": "添加 Billboard",
	"action.add_billboard.desc": "添加一个新的 Billboard，一个始终朝向相机的平面元素",
	"action.add_armature": "添加骨架",
	"action.add_armature.desc": "添加一组可以通过动画使网格变形的骨架",
	"action.add_armature_bone": "添加骨骼",
	"action.add_armature_bone.desc": "向骨架添加一根骨骼",
	"action.search_textures": "搜索纹理",
	"action.search_textures.desc": "按名称搜索纹理",
	"action.search_animations": "搜索动画",
	"action.search_animations.desc": "按名称搜索动画",
	"action.spline_selection_mode": "样条选择模式",
	"action.spline_selection_mode.object": "对象",
	"action.spline_selection_mode.handles": "手柄",
	"action.spline_render_mode": "几何体",
	"action.spline_render_mode.mesh": "网格",
	"action.spline_render_mode.path": "路径",
	"action.spline_render_mode.desc": "此样条应渲染哪种几何体",
	"action.spline_uv_mode": "UV 样式",
	"action.spline_uv_mode.length_accurate": "按长度分布",
	"action.spline_uv_mode.uniform": "均匀",
	"action.spline_uv_mode.per_segment": "按段",
	"action.spline_uv_mode.desc": "样条的管状网格应如何铺设 UV",
	"action.spline_ring_segments": "环段数",
	"action.spline_ring_segments.desc": "此样条每个管环的细分数量",
	"action.spline_tube_segments": "管段数",
	"action.spline_tube_segments.desc": "此样条沿路径的细分数量",
	"action.spline_tube_radius": "管半径",
	"action.spline_tube_radius.desc": "设置样条的管半径",
	"action.spline_display_space": "显示空间",
	"action.spline_display_space.desc": "在其路径上显示样条空间指示器",
	"action.spline_handle_mode": "样条手柄模式",
	"action.spline_handle_mode.desc": "用于变换样条手柄的模式",
	"action.spline_handle_mode.aligned": "对齐",
	"action.spline_handle_mode.free": "自由",
	"action.spline_handle_mode.mirrored": "镜像",
	"action.slider_weight_brush_size": "权重画笔大小",
	"action.weight_brush_xray": "权重画笔 X 光模式",
	"action.weight_brush_xray.desc": "启用后，权重画笔将影响所有顶点，而不只是表面可见的顶点",
	"action.apply_spline_rotation": "应用旋转",
	"action.apply_spline_rotation.desc": "重置样条的元素旋转，并将其改为应用到几何体上",
	"action.extrude_spline_selection": "挤出样条",
	"action.extrude_spline_selection.desc": "在所有样条上挤出所选手柄",
	"action.split_spline": "拆分样条",
	"action.split_spline.desc": "在所选手柄处将样条拆分为两条样条",
	"action.divide_spline_curve": "细分样条段",
	"action.divide_spline_curve.desc": "将样条段拆分为两个新段，并在交点处创建一个新手柄",
	"action.set_vertex_weights": "设置顶点权重",
	"action.set_vertex_weights.desc": "将所选顶点的权重设置为指定值，绑定到某个骨骼",
	"action.calculate_vertex_weights": "计算顶点权重",
	"action.calculate_vertex_weights.desc": "根据骨骼的位置自动分配顶点权重",
	"action.shelf_alignment": "工具架对齐",
	"action.shelf_alignment.desc": "选择工具架上项目的垂直对齐方式",
	"action.shelf_alignment.top": "顶部对齐",
	"action.shelf_alignment.bottom": "底部对齐",
	"action.view_mode.vertex_weight": "顶点权重",
	"action.view_mode.weighted_bone_colors": "顶点骨骼颜色",
	"action.create_animation_group": "创建动画组",
	"action.create_animation_group.desc": "创建一组动画",
	"action.move_graph_keyframes_up": "上移关键帧图表",
	"action.move_graph_keyframes_down": "下移关键帧图表",
	"menu.skin": "皮肤",
	"menu.text_edit.expression_editor": "表达式编辑器",
	"menu.color_picker.picker_type.normal": "法线贴图",
	"menu.texture.flipbook_animation": "翻页动画",
	"menu.panel.attach_to": "附加到",
	"menu.animation.playing": "播放中",
	"menu.animation_file.save_as": "另存为",
	"menu.animator.quaternion_interpolation": "四元数插值",
	"edit.extrude_spline_selection.extend": "延伸",
	"edit.divide_spline_curve.position": "位置",
	"group.bedrock_binding": "绑定",
	"group.cem_attach": "CEM 附加",
	"group.cem_model": "CEM 模型",
	"group.cem_scale": "CEM 缩放",
	"cube.rescale": "旋转重缩放",
	"cube.rescale.desc": "重新缩放方块以补偿旋转角度",
	"mesh.shading": "着色",
	"mesh.shading.flat": "平面",
	"mesh.shading.smooth": "平滑",
	"spline_mesh.cyclic": "闭合",
	"spline_mesh.cyclic.desc": "所选样条是否应形成一个环（闭合）",
	"billboard.offset": "偏移",
	"billboard.facing_mode": "朝向模式",
	"billboard.facing_mode.lookat": "看向",
	"billboard.facing_mode.lookat_y": "看向 Y",
	"billboard.facing_mode.rotate": "旋转",
	"billboard.facing_mode.rotate_y": "旋转 Y",
	"armature_bone.connected": "已连接",
	"reference_image.blueprint": "锁定蓝图",
	"codec.image.alpha_channel": "Alpha 通道",
	"codec.image.animation_fps": "动画 FPS",
	"panel.palette": "调色板",
	"panel.keyframe.change_effect_file": "更改效果文件",
	"panel.transform": "变换",
	"panel.element.spline_dimensions": "样条尺寸",
	"display.slot.on_shelf": "工具架",
	"display.reference.shelf": "工具架（全部槽位）",
	"display.reference.shelf_left": "工具架（左槽位）",
	"display.reference.shelf_center": "工具架（中槽位）",
	"display.reference.shelf_right": "工具架（右槽位）",
	"message.newer_project_format_version.title": "客户端过旧",
	"message.newer_project_format_version.message": "此文件是用较新的 Blockbench 版本保存的。请更新到 Blockbench %0 或更高版本以正确打开",
	"message.load_images.add_layer": "作为图层添加",
	"message.load_images.category.add_to_project": "添加到项目",
	"message.load_images.category.new_project": "新建项目",
	"message.load_palette.title": "加载调色板",
	"message.load_palette.message": "您确定要加载此调色板吗？这将替换当前的调色板。",
	"dialog.set_vertex_weights.weight": "权重",
	"dialog.set_vertex_weights.overwrite": "覆盖其他骨骼",
	"action.element_render_order.short": "渲染顺序",
	"action.element_render_order.desc": "元素的渲染顺序。这可以帮助修复带透明纹理的元素被其他元素遮挡的问题。不透明元素请保持为“自动”。",
	"spline.shading.flat": "平面",
	"spline.shading.smooth": "平滑",
	"spline.shading": "着色",
	"spline.shading.desc": "此样条的管状网格应如何着色",
	"action.slider_weight_brush_limit": "权重画笔限制",
	"action.slider_weight_brush_limit.desc": "为权重画笔能分配给顶点的权重设置上限",
	"action.weight_brush_blend_mode": "权重画笔混合模式",
	"action.weight_brush_blend_mode.set": "设置",
	"action.weight_brush_blend_mode.add": "添加",
	"action.apply_texture_to_elements": "应用纹理到元素",
	"action.apply_texture_to_elements.desc": "将所选纹理应用到所选元素",
	"menu.panel.reset_size": "重置大小",
	"action.import_layer": "导入图层",
	"action.import_layer.desc": "将图像文件作为图层导入",
	"menu.collection.open_file": "打开文件",
	"layout.version": "版本",
	"settings.status_bar_transform_sliders": "状态栏中的变换滑块",
	"settings.status_bar_transform_sliders.desc": "在状态栏中显示所选工具的变换滑块工具栏，而不是使用变换面板",
	"settings.default_bedrock_format": "默认 Bedrock 格式",
	"settings.default_bedrock_format.desc": "无法自动识别格式时，用于加载 Minecraft Bedrock 模型的默认格式",
	"settings.limit_brush_opacity_per_stroke": "限制每次笔画的不透明度",
	"settings.limit_brush_opacity_per_stroke.desc": "将笔刷在每次笔画中可应用的不透明度限制为不透明度滑块的值。使用平滑画笔时，这种行为可能会导致轻微的噪点",
	"action.merge_splines": "合并样条",
	"action.merge_splines.desc": "将多个样条合并为一个",
	"settings.default_java_block_version": "默认 Java 方块/物品版本",
	"settings.default_java_block_version.desc": "创建新的 Java 方块/物品模型或打开没有格式版本的文件时使用的默认格式版本",
	"data.bounding_box": "包围盒",
	"keys.option": "Option",
	"keys.slide_lmb_horizontal": "左键横向滑动",
	"keys.slide_lmb_vertical": "左键纵向滑动",
	"keys.slide_rmb_horizontal": "右键横向滑动",
	"keys.slide_rmb_vertical": "右键纵向滑动",
	"message.recover_backup.unknown_project": "未知项目",
	"message.recover_backup.discard_others": "丢弃其他所有备份",
	"message.unsupported_file_extension.title": "不支持的文件格式",
	"message.unsupported_file_extension.message": "无法打开文件 %0，该格式不受支持。你可能需要安装一个插件来处理此文件类型。",
	"message.unsupported_file_extension.open_in_default_program": "用默认程序打开",
	"dialog.project.uv_size": "UV 尺寸",
	"dialog.collection.offset": "偏移",
	"dialog.texture.fps": "FPS",
	"dialog.texture.fps.desc": "纹理翻页动画的每秒帧数",
	"dialog.edit_uv_size.title": "编辑 UV 尺寸",
	"dialog.edit_uv_size.target": "目标",
	"dialog.edit_uv_size.adjust": "调整方式",
	"dialog.edit_uv_size.adjust.adjust_uv": "反向调整 UV",
	"dialog.edit_uv_size.adjust.adjust_scale": "反向调整 UV 和缩放",
	"dialog.edit_uv_size.adjust.keep": "保持 UV 不变",
	"dialog.edit_uv_size.target_size": "目标 UV 尺寸",
	"dialog.edit_uv_size.preset.original": "原始",
	"dialog.edit_uv_size.preset.match_texture": "匹配纹理",
	"dialog.edit_uv_size.result": "结果",
	"dialog.edit_uv_size.result.textures": "纹理",
	"dialog.adjust_brightness_contrast.brightness": "亮度",
	"dialog.adjust_brightness_contrast.contrast": "对比度",
	"dialog.adjust_saturation_hue.saturation": "饱和度",
	"dialog.adjust_saturation_hue.hue": "色调",
	"dialog.adjust_opacity.mode": "模式",
	"dialog.adjust_opacity.mode.multiply": "相乘",
	"dialog.adjust_opacity.mode.set": "设置",
	"dialog.bedrock_bounding_box.type": "类型",
	"dialog.bedrock_bounding_box.type.collision_box": "碰撞箱",
	"dialog.bedrock_bounding_box.type.selection_box": "选择框",
	"dialog.bedrock_bounding_box.type.hitbox": "命中箱",
	"dialog.bedrock_bounding_box.hitbox_note": "请注意，实体命中箱仅在一定尺寸范围内有效，并且可能无法适应游戏中实体的旋转。",
	"dialog.bedrock_bounding_box.collision_note": "请注意，实体碰撞箱仅支持一个居中的、顶部轮廓为正方形的形状。",
	"dialog.bedrock_bounding_box.no_bounding_boxes": "此项目中不存在包围盒",
	"dialog.install_plugins_from_list.ids": "插件 ID",
	"dialog.install_plugins_from_list.info": "从 ID 列表批量安装插件。安装前，请确认你确实需要所有这些插件。保留不使用的插件可能会增加出现错误和未来更新不兼容的风险。",
	"dialog.copy_installed_plugins.details": "包含详细信息",
	"dialog.flip_animation.phase_offset": "相位偏移",
	"dialog.flip_animation.phase_offset.off": "关闭",
	"dialog.flip_animation.phase_offset.custom": "自定义",
	"dialog.flip_animation.clear_opposite": "覆写对侧",
	"settings.flipbook_textures_in_animation": "动画中播放翻页纹理",
	"settings.flipbook_textures_in_animation.desc": "在动画时间线中同步预览翻页纹理动画",
	"settings.display_uv": "UV 面显示范围",
	"settings.display_uv.desc": "选择在 UV 编辑器中显示哪些 UV 面",
	"settings.display_uv.selected_faces": "仅选中的面",
	"settings.display_uv.selected_elements": "选中元素的所有面",
	"settings.display_uv.all_elements": "所有元素的所有面",
	"settings.local_position_values": "局部空间位置值",
	"settings.local_position_values.desc": "在变换面板中以局部空间显示所有位置值",
	"settings.transform_cube_from_center": "从中心变换方块",
	"settings.transform_cube_from_center.desc": "从中心而非角点编辑方块的位置值",
	"settings.color_picker_tool_switch": "拾色器工具切换",
	"settings.color_picker_tool_switch.desc": "拾取透明像素时自动切换为橡皮擦；若先前处于橡皮擦状态，拾取颜色时自动切换为画笔",
	"keybind.preview_scroll_zoom": "缩放视图",
	"keybind.uv_editor_scroll_zoom": "缩放 UV/2D 编辑器",
	"action.blend_mode.alpha_mask": "Alpha 蒙版",
	"action.swap_tools.hold": "按住切换（拾色器）",
	"action.import_bedrock_voxel_shape": "导入 Bedrock 版体素形状",
	"action.import_bedrock_voxel_shape.desc": "从 JSON 文件中将体素形状添加到当前项目",
	"action.export_bedrock_voxel_shape": "导出 Bedrock 版体素形状",
	"action.export_bedrock_voxel_shape.desc": "将项目中的包围盒导出为 Bedrock 版体素形状文件",
	"action.plugins_window_menu": "菜单",
	"action.copy_installed_plugins": "复制已安装插件列表",
	"action.copy_installed_plugins.desc": "生成并复制当前已安装插件的列表",
	"action.install_plugins_from_list": "从列表安装插件",
	"action.install_plugins_from_list.desc": "从插件 ID 列表批量安装插件",
	"action.add_bounding_box": "添加包围盒",
	"action.add_bounding_box.desc": "添加一个新的包围盒",
	"action.split_alpha_into_layer": "分离 Alpha 通道为图层",
	"action.split_alpha_into_layer.desc": "将纹理的 Alpha 通道分离为一个 Alpha 蒙版图层",
	"action.generate_bedrock_block_box": "复制碰撞/选择框组件",
	"action.generate_bedrock_block_box.desc": "为 Minecraft Bedrock 版方块生成碰撞或选择框组件",
	"action.generate_bedrock_entity_box": "复制碰撞/命中箱组件",
	"action.generate_bedrock_entity_box.desc": "为 Minecraft Bedrock 版实体生成碰撞或自定义命中检测组件",
	"action.refresh_texture": "刷新纹理",
	"action.refresh_texture.desc": "从文件重新加载纹理",
	"action.move_uv_to_cursor": "将 UV 移至光标",
	"action.move_uv_to_cursor.desc": "将选中的 UV 面移动到鼠标光标所在位置",
	"action.edit_mode_uv_overlay": "显示所有元素",
	"action.round_keyframe_values": "取整关键帧值",
	"action.round_keyframe_values.desc": "将选中关键帧的所有值四舍五入取整",
	"action.keyframe_column_create.all_channels": "所有通道",
	"action.keyframe_column_create.all_channels.desc": "为所有通道初始化关键帧，即使该通道之前没有关键帧",
	"action.add_all_to_timeline": "全部添加到时间线",
	"action.mirror_animating": "镜像动画编辑",
	"action.mirror_animating.desc": "将动画编辑镜像到对侧",
	"action.copy_animation_pose": "复制动画姿态",
	"action.copy_animation_pose.desc": "复制关键帧以复现当前动画姿态",
	"menu.texture.file_format": "文件格式",
	"menu.texture.wrap_mode": "环绕模式",
	"menu.texture.wrap_mode.limited": "受限",
	"menu.texture.wrap_mode.repeat": "重复",
	"menu.texture.wrap_mode.clamp": "边缘钳制",
	"edit.reparent_selection.adjust_position": "保持世界变换",
	"texture_mesh.texture_name": "纹理名称",
	"display.slot.embedded": "内嵌",
	"display.animate_preview": "预览动画",
	"display.reference.flower_pot": "花盆",
	"data.generated_item_mesh": "Generated Item Model",
	"message.generated_item_model.title": "Generated Item Model",
	"message.generated_item_model.message": "This model has no elements of its own. Minecraft builds the item shape from the model's texture, so what you see here is only a preview of that shape. It cannot be edited, and is not exported.\n\nTo change how the item looks in game, edit the texture.",
	"message.generated_item_model.edit_texture": "Edit Texture",
	"message.generated_item_model.convert": "Convert to Editable Model",
	"message.convert_generated_item_model.title": "Convert to Editable Model",
	"message.convert_generated_item_model.message": "This builds real elements by extruding the texture, so you can change the item shape in 3D.\n\nIf you only want to change how the item looks, you do not need this. Edit the texture instead, and Minecraft will keep generating the shape from it.",
	"message.convert_generated_item_model.confirm": "Extrude Texture",
	"message.generated_item_model_conflict.title": "Generated Item Model",
	"message.generated_item_model_conflict.message": "Minecraft cannot use both a generated item model and elements. Now that this model has elements, the generated shape is ignored in game.",
	"message.generated_item_model_conflict.convert": "Convert the Generated Model to Cubes",
	"message.generated_item_model_conflict.convert.desc": "Extrude the texture into real elements, so nothing is lost",
	"message.generated_item_model_conflict.remove": "Remove the Generated Model",
	"message.generated_item_model_conflict.remove.desc": "Delete the preview and model the item from scratch",
	"message.generated_item_model_conflict.keep": "Keep It as a Reference",
	"message.generated_item_model_conflict.keep.desc": "Show it in Blockbench only, never exported",
	"message.add_reference_image.globally": "Add for all projects",
	"dialog.extrude.orientation.upright_z": "Upright Z",
	"dialog.extrude.depth": "Depth",
	"dialog.add_primitive.shape.icosphere": "Icosphere",
	"dialog.add_primitive.shape.octahedron": "Octahedron",
	"dialog.add_primitive.shape.dodecahedron": "Dodecahedron",
	"dialog.add_primitive.detail": "Detail",
	"dialog.plugins.update": "Update",
	"dialog.plugins.update_available": "Update Available",
	"dialog.create_variable_placeholder.variable": "Variable",
	"dialog.create_variable_placeholder.type": "Type",
	"dialog.create_variable_placeholder.type.value": "Value",
	"dialog.create_variable_placeholder.type.slider": "Slider",
	"dialog.create_variable_placeholder.type.toggle": "Toggle",
	"dialog.create_variable_placeholder.type.impulse": "Impulse",
	"dialog.create_variable_placeholder.value": "Value",
	"dialog.create_variable_placeholder.duration": "Duration",
	"dialog.create_variable_placeholder.step": "Step",
	"dialog.create_variable_placeholder.range": "Range",
	"dialog.create_variable_placeholder.output": "Output",
	"dialog.view_built_in_variables.function": "Parameters required",
	"dialog.advanced_screenshot.export": "Export",
	"dialog.preview_options.show_element_markers": "Show Element Markers",
	"dialog.preview_options.show_element_markers.desc": "Display markers to indicate the position for elements such as bones, null objects, and locators",
	"settings.maximum_zoom_distance": "Maximum Zoom Distance",
	"settings.maximum_zoom_distance.desc": "How far the camera can be zoomed away from the model",
	"settings.constant_outlines": "Constant Outlines",
	"settings.constant_outlines.desc": "Always display element outlines regardless of selection",
	"settings.new_project_dialog": "New Project Dialog",
	"settings.new_project_dialog.desc": "Show the Project dialog when creating a new project",
	"settings.opacity_range": "Opacity Range",
	"settings.opacity_range.desc": "Select which range is used to control opacity of layers and brushes",
	"settings.automatic_plugin_updates": "Automatic Plugin Updates",
	"settings.automatic_plugin_updates.desc": "Automatically update plugins to keep them up-to-date",
	"settings.native_window_frame": "Native Window Frame",
	"settings.native_window_frame.desc": "Use a native window frame in the style of the OS",
	"keybind.preview_scroll_pan": "Scroll Pan View",
	"keybind.preview_scroll_pan.desc": "Use scroll to pan the view, can be used for two-finger panning with trackpads",
	"action.position_slider_per_element": "Move Individual Positions",
	"action.position_slider_per_element.desc": "When enabled, using the position sliders changes individual positions per element. When disabled, the whole selection moves in the selected transform space.",
	"action.origin_slider_direct_values": "Move Pivot Values Directly",
	"action.origin_slider_direct_values.desc": "When enabled, pivot sliders will move the pivot point directly, affecting the position of the object. When disabled, positions get adjusted automatically.",
	"action.brush_lock_mode": "Brush Lock Mode",
	"action.brush_lock_mode.none": "Unlocked",
	"action.brush_lock_mode.element": "Lock to Element",
	"action.brush_lock_mode.face": "Lock to Face",
	"action.slider_brush_aspect_ratio": "Brush Aspect Ratio",
	"action.slider_brush_aspect_ratio.desc": "Aspect ratio of the brush",
	"action.screen_space_brush_projection": "Screen Space Brush Projection",
	"action.screen_space_brush_projection.desc": "Use screen space projection for painting with a brush",
	"action.close_other_projects": "Close Other Tabs",
	"action.close_other_projects.desc": "Closes all projects except the open project",
	"action.close_projects_to_right": "Close Tabs to the Right",
	"action.close_projects_to_right.desc": "Closes all project tabs to the right of the open project",
	"action.extrude_texture_to_model": "Extrude Texture",
	"action.extrude_texture_to_model.desc": "Generate a model by extruding this texture",
	"action.experimental_settings": "Experimental Settings",
	"action.experimental_settings.desc": "Customize experimental developer settings",
	"action.convert_texture_mesh_to_cubes": "Convert to Extruded Model",
	"action.convert_texture_mesh_to_cubes.desc": "Replace the texture mesh with cubes extruded from its texture, in the same place",
	"action.flip_in_place": "Flip in Place %0",
	"action.flip_in_place.desc": "Flip the selected elements on the %0 axis in its current position",
	"action.create_layer_group": "Create Layer Group",
	"action.resolve_layer_group": "Resolve Layer Group",
	"action.preview_models": "Preview Models",
	"action.preview_models.desc": "Select and edit reference models",
	"action.keyframe_select_before_playhead": "Select Keyframes Before Playhead",
	"action.keyframe_select_before_playhead.desc": "Select all keyframes in the timeline at or before the playhead",
	"action.keyframe_select_after_playhead": "Select Keyframes After Playhead",
	"action.keyframe_select_after_playhead.desc": "Select all keyframes in the timeline at or after the playhead",
	"action.set_ik_pole": "Set IK Pole",
	"action.set_ik_pole.desc": "Select the pole that the chain will attempt to face towards while moving",
	"action.create_variable_placeholder": "Create Variable Placeholder",
	"action.create_variable_placeholder.desc": "Add a variable to the variable placeholders list to preview a value",
	"action.view_built_in_variables": "View Built-in Variables",
	"action.view_built_in_variables.desc": "Display the list of variables and their values that Blockbench automatically provides for animation preview",
	"menu.paint": "Paint",
	"menu.brush_presets.screen_space": "Screen Space Brush",
	"edit.loop_cut.spacing": "Spacing",
	"edit.loop_cut.spacing.proportional": "Proportional",
	"edit.loop_cut.spacing.even_start": "Even - From Start",
	"edit.loop_cut.spacing.even_end": "Even - From End",
	"cube.shade_direction_override": "Shade Direction Override",
	"cube.shade_direction_override.desc": "Shade every face of the cube as if it was facing this direction. If not set, each face is shaded based on the direction it actually faces. This does not affect ambient occlusion or shading based on light level.",
	"null_object.ik_target": "IK Target",
	"null_object.ik_source": "IK Root",
	"null_object.ik_pole": "IK Pole",
	"reference_image.layer.scene": "3D Scene",
	"reference_image.view_mode": "View Mode",
	"reference_image.view_mode.flat_image": "Flat Image",
	"reference_image.cull_backface": "Hide Backside",
	"codec.common.merge_armature_mesh": "Merge Armature Mesh",
	"preview_model.transform": "Transform",
	"preview_model.reset_transform": "Reset Transform",
	"preview_model.minecraft_player": "Minecraft Player",
	"dialog.generate_pbr_map.channel": "PBR Channel",
	"dialog.generate_pbr_map.channel.metalness": "Metalness",
	"dialog.generate_pbr_map.channel.emissive": "Emissive",
	"dialog.generate_pbr_map.channel.roughness": "Roughness",
	"dialog.generate_pbr_map.method": "Source",
	"dialog.generate_pbr_map.method.value": "Value",
	"dialog.generate_pbr_map.method.brightness": "Brightness",
	"dialog.generate_pbr_map.method.saturation": "Saturation",
	"dialog.generate_pbr_map.method.hue": "Hue",
	"dialog.generate_pbr_map.method.red": "Red",
	"dialog.generate_pbr_map.method.green": "Green",
	"dialog.generate_pbr_map.method.blue": "Blue",
	"dialog.generate_pbr_map.method.empty": "Empty",
	"dialog.generate_pbr_map.in_range": "Input Range",
	"dialog.generate_pbr_map.out_range": "Output Range",
	"dialog.generate_pbr_map.invert": "Invert",
	"dialog.generate_pbr_map.preset": "Preset",
	"dialog.generate_pbr_map.preset.apply_preset": "Apply Preset",
	"dialog.generate_pbr_map.update_values": "Update with current values",
	"dialog.generate_pbr_map.preset.new_preset": "New Preset...",
	"action.image_editor_checkerboard": "Checkerboard",
	"action.image_editor_checkerboard.desc": "Toggle the checkerboard background of the 2D Editor",
	"message.child_model_only.resolve": "Resolve Parent Models",
	"message.child_model_only.resolve.desc": "Merge the whole parent chain into this model",
	"message.child_model_only.open.desc": "Open the parent in a new tab, keeping it separate from this model",
	"action.brush_lock_mode.selected_faces": "Lock to Selected Faces",
	"reference_image.view_mode.plane": "3D Plane",
	"preview_model.minecraft_crafting_table": "Minecraft Crafting Table",
	"dialog.extrude.animated": "Animated Texture",
	"dialog.scale.box_uv_warning_required": "Scaling cubes that use Box UV may break the UV mapping. Instead, try to scale your model during implementation, or use Inflate.",
	"menu.color_picker.picker_type.wheel_static": "Wheel (Static)"
}